/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as WelcomeRouteImport } from './routes/welcome'
import { Route as VerifyEmailChangeRouteImport } from './routes/verify-email-change'
import { Route as VerifyAccountRouteImport } from './routes/verify-account'
import { Route as PackagesRouteImport } from './routes/packages'
import { Route as InfluencersListRouteImport } from './routes/influencers-list'
import { Route as ExploreBrandsRouteImport } from './routes/explore-brands'
import { Route as UnauthenticatedRouteImport } from './routes/_unauthenticated'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as IndexRouteImport } from './routes/index'
import { Route as UnsubscribeTokenRouteImport } from './routes/unsubscribe.$token'
import { Route as JoinSlugRouteImport } from './routes/join.$slug'
import { Route as UnauthenticatedVerifyEmailRouteImport } from './routes/_unauthenticated/verify-email'
import { Route as UnauthenticatedResetPasswordRouteImport } from './routes/_unauthenticated/reset-password'
import { Route as UnauthenticatedRequestResetRouteImport } from './routes/_unauthenticated/request-reset'
import { Route as UnauthenticatedOnboardingRouteImport } from './routes/_unauthenticated/onboarding'
import { Route as UnauthenticatedLoginRouteImport } from './routes/_unauthenticated/login'
import { Route as AuthenticatedSearchVisibilityRouteImport } from './routes/_authenticated/search-visibility'
import { Route as AuthenticatedProfileRouteImport } from './routes/_authenticated/profile'
import { Route as AuthenticatedPlansRouteImport } from './routes/_authenticated/plans'
import { Route as AuthenticatedMediaLibraryRouteImport } from './routes/_authenticated/media-library'
import { Route as AuthenticatedLogoutRouteImport } from './routes/_authenticated/logout'
import { Route as AuthenticatedImageUploadRouteImport } from './routes/_authenticated/image-upload'
import { Route as AuthenticatedGroupsRouteImport } from './routes/_authenticated/groups'
import { Route as AuthenticatedChatRouteImport } from './routes/_authenticated/chat'
import { Route as AuthenticatedCampaignsRouteImport } from './routes/_authenticated/campaigns'
import { Route as AuthenticatedCompanyRouteImport } from './routes/_authenticated/_company'
import { Route as AuthenticatedAgencyRouteImport } from './routes/_authenticated/_agency'
import { Route as AuthenticatedAdminRouteImport } from './routes/_authenticated/_admin'
import { Route as InfluencerInfluencerIdIndexRouteImport } from './routes/influencer.$influencerId.index'
import { Route as CampaignCampaignIdIndexRouteImport } from './routes/campaign.$campaignId.index'
import { Route as UnauthenticatedRegisterIndexRouteImport } from './routes/_unauthenticated/register.index'
import { Route as EmbedJoinSlugRouteImport } from './routes/embed.join.$slug'
import { Route as UnauthenticatedRegisterAgencyRouteImport } from './routes/_unauthenticated/register.agency'
import { Route as AuthenticatedCampaignReportingCampaignIdRouteImport } from './routes/_authenticated/campaign-reporting.$campaignId'
import { Route as AuthenticatedCampaignManagementCampaignIdRouteImport } from './routes/_authenticated/campaign-management.$campaignId'
import { Route as AuthenticatedCampaignManagementOngoingCampaignIdRouteImport } from './routes/_authenticated/campaign-management-ongoing.$campaignId'
import { Route as AuthenticatedGroupGroupIdIndexRouteImport } from './routes/_authenticated/group.$groupId.index'
import { Route as AuthenticatedAdminAdminsIndexRouteImport } from './routes/_authenticated/_admin/admins.index'
import { Route as AuthenticatedInfluencerInfluencerIdEditRouteImport } from './routes/_authenticated/influencer.$influencerId.edit'
import { Route as AuthenticatedCompanyCompanyIdWelcomeRouteImport } from './routes/_authenticated/company.$companyId.welcome'
import { Route as AuthenticatedCompanyCompanyIdEditRouteImport } from './routes/_authenticated/company.$companyId.edit'
import { Route as AuthenticatedCampaignCampaignIdEditRouteImport } from './routes/_authenticated/campaign.$campaignId.edit'
import { Route as AuthenticatedAdminAdminsTiktokMediaManagerRouteImport } from './routes/_authenticated/_admin/admins.tiktok-media-manager'
import { Route as AuthenticatedAdminAdminsInstagramMediaManagerRouteImport } from './routes/_authenticated/_admin/admins.instagram-media-manager'
import { Route as AuthenticatedAdminAdminsImpersonateRouteImport } from './routes/_authenticated/_admin/admins.impersonate'
import { Route as AuthenticatedAdminAdminsHubRouteImport } from './routes/_authenticated/_admin/admins.hub'
import { Route as AuthenticatedAdminAdminsCustomersRouteImport } from './routes/_authenticated/_admin/admins.customers'
import { Route as AuthenticatedAdminAdminsCustomerSuccessRouteImport } from './routes/_authenticated/_admin/admins.customer-success'
import { Route as AuthenticatedAdminAdminsBulkSmsRouteImport } from './routes/_authenticated/_admin/admins.bulk-sms'
import { Route as AuthenticatedAdminAdminsBulkNotificationRouteImport } from './routes/_authenticated/_admin/admins.bulk-notification'
import { Route as AuthenticatedAdminLegacyTiktokMediaManagerRouteImport } from './routes/_authenticated/_admin/_legacy/tiktok-media-manager'
import { Route as AuthenticatedAdminLegacyInstagramMediaManagerRouteImport } from './routes/_authenticated/_admin/_legacy/instagram-media-manager'
import { Route as AuthenticatedAdminLegacyCustomersRouteImport } from './routes/_authenticated/_admin/_legacy/customers'
import { Route as AuthenticatedAdminLegacyBulkSmsRouteImport } from './routes/_authenticated/_admin/_legacy/bulk-sms'
import { Route as AuthenticatedAdminLegacyBulkNotificationRouteImport } from './routes/_authenticated/_admin/_legacy/bulk-notification'
import { Route as AuthenticatedCompanyCompanyCompanyIdIndexRouteImport } from './routes/_authenticated/_company/company.$companyId.index'
import { Route as AuthenticatedAgencyAgencyAgencyIdIndexRouteImport } from './routes/_authenticated/_agency/agency.$agencyId.index'
import { Route as AuthenticatedAdminAdminsBoostEstimateIndexRouteImport } from './routes/_authenticated/_admin/admins.boost-estimate.index'
import { Route as AuthenticatedCompanyCompanyCompanyIdSentAmbassadorInvitesRouteImport } from './routes/_authenticated/_company/company.$companyId.sent-ambassador-invites'
import { Route as AuthenticatedCompanyCompanyCompanyIdSearchVisibilityRouteImport } from './routes/_authenticated/_company/company.$companyId.search-visibility'
import { Route as AuthenticatedCompanyCompanyCompanyIdPendingAmbassadorsRouteImport } from './routes/_authenticated/_company/company.$companyId.pending-ambassadors'
import { Route as AuthenticatedCompanyCompanyCompanyIdMediaLibraryRouteImport } from './routes/_authenticated/_company/company.$companyId.media-library'
import { Route as AuthenticatedCompanyCompanyCompanyIdInvoicesRouteImport } from './routes/_authenticated/_company/company.$companyId.invoices'
import { Route as AuthenticatedCompanyCompanyCompanyIdGroupsRouteImport } from './routes/_authenticated/_company/company.$companyId.groups'
import { Route as AuthenticatedCompanyCompanyCompanyIdDashboardRouteImport } from './routes/_authenticated/_company/company.$companyId.dashboard'
import { Route as AuthenticatedCompanyCompanyCompanyIdBlockedInfluencersRouteImport } from './routes/_authenticated/_company/company.$companyId.blocked-influencers'
import { Route as AuthenticatedCompanyLegacyMy_campaignsCompanyIdRouteImport } from './routes/_authenticated/_company/_legacy/my_campaigns.$companyId'
import { Route as AuthenticatedCompanyLegacyCompanyEditCompanyIdRouteImport } from './routes/_authenticated/_company/_legacy/company-edit.$companyId'
import { Route as AuthenticatedAgencyAgencyAgencyIdMediaLibraryRouteImport } from './routes/_authenticated/_agency/agency.$agencyId.media-library'
import { Route as AuthenticatedAgencyAgencyAgencyIdGroupsRouteImport } from './routes/_authenticated/_agency/agency.$agencyId.groups'
import { Route as AuthenticatedAgencyAgencyAgencyIdEditRouteImport } from './routes/_authenticated/_agency/agency.$agencyId.edit'
import { Route as AuthenticatedAgencyAgencyAgencyIdDashboardRouteImport } from './routes/_authenticated/_agency/agency.$agencyId.dashboard'
import { Route as AuthenticatedAgencyAgencyAgencyIdCustomersRouteImport } from './routes/_authenticated/_agency/agency.$agencyId.customers'
import { Route as AuthenticatedAdminAdminsBoostEstimateCampaignIdRouteImport } from './routes/_authenticated/_admin/admins.boost-estimate.$campaignId'
import { Route as AuthenticatedAdminAdminsAgencyCreateRouteImport } from './routes/_authenticated/_admin/admins.agency.create'
import { Route as AuthenticatedAdminAdminsAccountsCombineRouteImport } from './routes/_authenticated/_admin/admins.accounts.combine'
import { Route as AuthenticatedAdminLegacyAgencyCreateRouteImport } from './routes/_authenticated/_admin/_legacy/agency.create'
import { Route as AuthenticatedAdminLegacyAccountsCombineRouteImport } from './routes/_authenticated/_admin/_legacy/accounts.combine'
import { Route as AuthenticatedCompanyCompanyCompanyIdCampaignsStatusRouteImport } from './routes/_authenticated/_company/company.$companyId.campaigns.$status'
import { Route as AuthenticatedAgencyAgencyAgencyIdCampaignsStatusRouteImport } from './routes/_authenticated/_agency/agency.$agencyId.campaigns.$status'
import { Route as AuthenticatedAgencyAgencyAgencyIdSubbrandCompanyIdIndexRouteImport } from './routes/_authenticated/_agency/agency.$agencyId.subbrand.$companyId.index'
import { Route as AuthenticatedCompanyCompanyCompanyIdChatChar123CampaignIdChar125Char123InfluencerUserIdChar125RouteImport } from './routes/_authenticated/_company/company.$companyId.chat.{-$campaignId}.{-$influencerUserId}'
import { Route as AuthenticatedAgencyAgencyAgencyIdSubbrandCompanyIdSentAmbassadorInvitesRouteImport } from './routes/_authenticated/_agency/agency.$agencyId.subbrand.$companyId.sent-ambassador-invites'
import { Route as AuthenticatedAgencyAgencyAgencyIdSubbrandCompanyIdSearchVisibilityRouteImport } from './routes/_authenticated/_agency/agency.$agencyId.subbrand.$companyId.search-visibility'
import { Route as AuthenticatedAgencyAgencyAgencyIdSubbrandCompanyIdPendingAmbassadorsRouteImport } from './routes/_authenticated/_agency/agency.$agencyId.subbrand.$companyId.pending-ambassadors'
import { Route as AuthenticatedAgencyAgencyAgencyIdSubbrandCompanyIdMediaLibraryRouteImport } from './routes/_authenticated/_agency/agency.$agencyId.subbrand.$companyId.media-library'
import { Route as AuthenticatedAgencyAgencyAgencyIdSubbrandCompanyIdInvoicesRouteImport } from './routes/_authenticated/_agency/agency.$agencyId.subbrand.$companyId.invoices'
import { Route as AuthenticatedAgencyAgencyAgencyIdSubbrandCompanyIdGroupsRouteImport } from './routes/_authenticated/_agency/agency.$agencyId.subbrand.$companyId.groups'
import { Route as AuthenticatedAgencyAgencyAgencyIdSubbrandCompanyIdEditRouteImport } from './routes/_authenticated/_agency/agency.$agencyId.subbrand.$companyId.edit'
import { Route as AuthenticatedAgencyAgencyAgencyIdSubbrandCompanyIdDashboardRouteImport } from './routes/_authenticated/_agency/agency.$agencyId.subbrand.$companyId.dashboard'
import { Route as AuthenticatedAgencyAgencyAgencyIdSubbrandCompanyIdBlockedInfluencersRouteImport } from './routes/_authenticated/_agency/agency.$agencyId.subbrand.$companyId.blocked-influencers'
import { Route as AuthenticatedAgencyAgencyAgencyIdSubbrandCompanyIdCampaignsStatusRouteImport } from './routes/_authenticated/_agency/agency.$agencyId.subbrand.$companyId.campaigns.$status'
import { Route as AuthenticatedAgencyAgencyAgencyIdChatCompanyIdChar123CampaignIdChar125Char123InfluencerUserIdChar125RouteImport } from './routes/_authenticated/_agency/agency.$agencyId.chat.$companyId.{-$campaignId}.{-$influencerUserId}'

const WelcomeRoute = WelcomeRouteImport.update({
  id: '/welcome',
  path: '/welcome',
  getParentRoute: () => rootRouteImport,
} as any)
const VerifyEmailChangeRoute = VerifyEmailChangeRouteImport.update({
  id: '/verify-email-change',
  path: '/verify-email-change',
  getParentRoute: () => rootRouteImport,
} as any)
const VerifyAccountRoute = VerifyAccountRouteImport.update({
  id: '/verify-account',
  path: '/verify-account',
  getParentRoute: () => rootRouteImport,
} as any)
const PackagesRoute = PackagesRouteImport.update({
  id: '/packages',
  path: '/packages',
  getParentRoute: () => rootRouteImport,
} as any)
const InfluencersListRoute = InfluencersListRouteImport.update({
  id: '/influencers-list',
  path: '/influencers-list',
  getParentRoute: () => rootRouteImport,
} as any)
const ExploreBrandsRoute = ExploreBrandsRouteImport.update({
  id: '/explore-brands',
  path: '/explore-brands',
  getParentRoute: () => rootRouteImport,
} as any)
const UnauthenticatedRoute = UnauthenticatedRouteImport.update({
  id: '/_unauthenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const UnsubscribeTokenRoute = UnsubscribeTokenRouteImport.update({
  id: '/unsubscribe/$token',
  path: '/unsubscribe/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const JoinSlugRoute = JoinSlugRouteImport.update({
  id: '/join/$slug',
  path: '/join/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const UnauthenticatedVerifyEmailRoute =
  UnauthenticatedVerifyEmailRouteImport.update({
    id: '/verify-email',
    path: '/verify-email',
    getParentRoute: () => UnauthenticatedRoute,
  } as any)
const UnauthenticatedResetPasswordRoute =
  UnauthenticatedResetPasswordRouteImport.update({
    id: '/reset-password',
    path: '/reset-password',
    getParentRoute: () => UnauthenticatedRoute,
  } as any)
const UnauthenticatedRequestResetRoute =
  UnauthenticatedRequestResetRouteImport.update({
    id: '/request-reset',
    path: '/request-reset',
    getParentRoute: () => UnauthenticatedRoute,
  } as any)
const UnauthenticatedOnboardingRoute =
  UnauthenticatedOnboardingRouteImport.update({
    id: '/onboarding',
    path: '/onboarding',
    getParentRoute: () => UnauthenticatedRoute,
  } as any)
const UnauthenticatedLoginRoute = UnauthenticatedLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => UnauthenticatedRoute,
} as any)
const AuthenticatedSearchVisibilityRoute =
  AuthenticatedSearchVisibilityRouteImport.update({
    id: '/search-visibility',
    path: '/search-visibility',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedProfileRoute = AuthenticatedProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedPlansRoute = AuthenticatedPlansRouteImport.update({
  id: '/plans',
  path: '/plans',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedMediaLibraryRoute =
  AuthenticatedMediaLibraryRouteImport.update({
    id: '/media-library',
    path: '/media-library',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedLogoutRoute = AuthenticatedLogoutRouteImport.update({
  id: '/logout',
  path: '/logout',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedImageUploadRoute =
  AuthenticatedImageUploadRouteImport.update({
    id: '/image-upload',
    path: '/image-upload',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedGroupsRoute = AuthenticatedGroupsRouteImport.update({
  id: '/groups',
  path: '/groups',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedChatRoute = AuthenticatedChatRouteImport.update({
  id: '/chat',
  path: '/chat',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedCampaignsRoute = AuthenticatedCampaignsRouteImport.update({
  id: '/campaigns',
  path: '/campaigns',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedCompanyRoute = AuthenticatedCompanyRouteImport.update({
  id: '/_company',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedAgencyRoute = AuthenticatedAgencyRouteImport.update({
  id: '/_agency',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedAdminRoute = AuthenticatedAdminRouteImport.update({
  id: '/_admin',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const InfluencerInfluencerIdIndexRoute =
  InfluencerInfluencerIdIndexRouteImport.update({
    id: '/influencer/$influencerId/',
    path: '/influencer/$influencerId/',
    getParentRoute: () => rootRouteImport,
  } as any)
const CampaignCampaignIdIndexRoute = CampaignCampaignIdIndexRouteImport.update({
  id: '/campaign/$campaignId/',
  path: '/campaign/$campaignId/',
  getParentRoute: () => rootRouteImport,
} as any)
const UnauthenticatedRegisterIndexRoute =
  UnauthenticatedRegisterIndexRouteImport.update({
    id: '/register/',
    path: '/register/',
    getParentRoute: () => UnauthenticatedRoute,
  } as any)
const EmbedJoinSlugRoute = EmbedJoinSlugRouteImport.update({
  id: '/embed/join/$slug',
  path: '/embed/join/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const UnauthenticatedRegisterAgencyRoute =
  UnauthenticatedRegisterAgencyRouteImport.update({
    id: '/register/agency',
    path: '/register/agency',
    getParentRoute: () => UnauthenticatedRoute,
  } as any)
const AuthenticatedCampaignReportingCampaignIdRoute =
  AuthenticatedCampaignReportingCampaignIdRouteImport.update({
    id: '/campaign-reporting/$campaignId',
    path: '/campaign-reporting/$campaignId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedCampaignManagementCampaignIdRoute =
  AuthenticatedCampaignManagementCampaignIdRouteImport.update({
    id: '/campaign-management/$campaignId',
    path: '/campaign-management/$campaignId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedCampaignManagementOngoingCampaignIdRoute =
  AuthenticatedCampaignManagementOngoingCampaignIdRouteImport.update({
    id: '/campaign-management-ongoing/$campaignId',
    path: '/campaign-management-ongoing/$campaignId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedGroupGroupIdIndexRoute =
  AuthenticatedGroupGroupIdIndexRouteImport.update({
    id: '/group/$groupId/',
    path: '/group/$groupId/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAdminAdminsIndexRoute =
  AuthenticatedAdminAdminsIndexRouteImport.update({
    id: '/admins/',
    path: '/admins/',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedInfluencerInfluencerIdEditRoute =
  AuthenticatedInfluencerInfluencerIdEditRouteImport.update({
    id: '/influencer/$influencerId/edit',
    path: '/influencer/$influencerId/edit',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedCompanyCompanyIdWelcomeRoute =
  AuthenticatedCompanyCompanyIdWelcomeRouteImport.update({
    id: '/company/$companyId/welcome',
    path: '/company/$companyId/welcome',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedCompanyCompanyIdEditRoute =
  AuthenticatedCompanyCompanyIdEditRouteImport.update({
    id: '/company/$companyId/edit',
    path: '/company/$companyId/edit',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedCampaignCampaignIdEditRoute =
  AuthenticatedCampaignCampaignIdEditRouteImport.update({
    id: '/campaign/$campaignId/edit',
    path: '/campaign/$campaignId/edit',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAdminAdminsTiktokMediaManagerRoute =
  AuthenticatedAdminAdminsTiktokMediaManagerRouteImport.update({
    id: '/admins/tiktok-media-manager',
    path: '/admins/tiktok-media-manager',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminAdminsInstagramMediaManagerRoute =
  AuthenticatedAdminAdminsInstagramMediaManagerRouteImport.update({
    id: '/admins/instagram-media-manager',
    path: '/admins/instagram-media-manager',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminAdminsImpersonateRoute =
  AuthenticatedAdminAdminsImpersonateRouteImport.update({
    id: '/admins/impersonate',
    path: '/admins/impersonate',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminAdminsHubRoute =
  AuthenticatedAdminAdminsHubRouteImport.update({
    id: '/admins/hub',
    path: '/admins/hub',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminAdminsCustomersRoute =
  AuthenticatedAdminAdminsCustomersRouteImport.update({
    id: '/admins/customers',
    path: '/admins/customers',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminAdminsCustomerSuccessRoute =
  AuthenticatedAdminAdminsCustomerSuccessRouteImport.update({
    id: '/admins/customer-success',
    path: '/admins/customer-success',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminAdminsBulkSmsRoute =
  AuthenticatedAdminAdminsBulkSmsRouteImport.update({
    id: '/admins/bulk-sms',
    path: '/admins/bulk-sms',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminAdminsBulkNotificationRoute =
  AuthenticatedAdminAdminsBulkNotificationRouteImport.update({
    id: '/admins/bulk-notification',
    path: '/admins/bulk-notification',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminLegacyTiktokMediaManagerRoute =
  AuthenticatedAdminLegacyTiktokMediaManagerRouteImport.update({
    id: '/_legacy/tiktok-media-manager',
    path: '/tiktok-media-manager',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminLegacyInstagramMediaManagerRoute =
  AuthenticatedAdminLegacyInstagramMediaManagerRouteImport.update({
    id: '/_legacy/instagram-media-manager',
    path: '/instagram-media-manager',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminLegacyCustomersRoute =
  AuthenticatedAdminLegacyCustomersRouteImport.update({
    id: '/_legacy/customers',
    path: '/customers',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminLegacyBulkSmsRoute =
  AuthenticatedAdminLegacyBulkSmsRouteImport.update({
    id: '/_legacy/bulk-sms',
    path: '/bulk-sms',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminLegacyBulkNotificationRoute =
  AuthenticatedAdminLegacyBulkNotificationRouteImport.update({
    id: '/_legacy/bulk-notification',
    path: '/bulk-notification',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedCompanyCompanyCompanyIdIndexRoute =
  AuthenticatedCompanyCompanyCompanyIdIndexRouteImport.update({
    id: '/company/$companyId/',
    path: '/company/$companyId/',
    getParentRoute: () => AuthenticatedCompanyRoute,
  } as any)
const AuthenticatedAgencyAgencyAgencyIdIndexRoute =
  AuthenticatedAgencyAgencyAgencyIdIndexRouteImport.update({
    id: '/agency/$agencyId/',
    path: '/agency/$agencyId/',
    getParentRoute: () => AuthenticatedAgencyRoute,
  } as any)
const AuthenticatedAdminAdminsBoostEstimateIndexRoute =
  AuthenticatedAdminAdminsBoostEstimateIndexRouteImport.update({
    id: '/admins/boost-estimate/',
    path: '/admins/boost-estimate/',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedCompanyCompanyCompanyIdSentAmbassadorInvitesRoute =
  AuthenticatedCompanyCompanyCompanyIdSentAmbassadorInvitesRouteImport.update({
    id: '/company/$companyId/sent-ambassador-invites',
    path: '/company/$companyId/sent-ambassador-invites',
    getParentRoute: () => AuthenticatedCompanyRoute,
  } as any)
const AuthenticatedCompanyCompanyCompanyIdSearchVisibilityRoute =
  AuthenticatedCompanyCompanyCompanyIdSearchVisibilityRouteImport.update({
    id: '/company/$companyId/search-visibility',
    path: '/company/$companyId/search-visibility',
    getParentRoute: () => AuthenticatedCompanyRoute,
  } as any)
const AuthenticatedCompanyCompanyCompanyIdPendingAmbassadorsRoute =
  AuthenticatedCompanyCompanyCompanyIdPendingAmbassadorsRouteImport.update({
    id: '/company/$companyId/pending-ambassadors',
    path: '/company/$companyId/pending-ambassadors',
    getParentRoute: () => AuthenticatedCompanyRoute,
  } as any)
const AuthenticatedCompanyCompanyCompanyIdMediaLibraryRoute =
  AuthenticatedCompanyCompanyCompanyIdMediaLibraryRouteImport.update({
    id: '/company/$companyId/media-library',
    path: '/company/$companyId/media-library',
    getParentRoute: () => AuthenticatedCompanyRoute,
  } as any)
const AuthenticatedCompanyCompanyCompanyIdInvoicesRoute =
  AuthenticatedCompanyCompanyCompanyIdInvoicesRouteImport.update({
    id: '/company/$companyId/invoices',
    path: '/company/$companyId/invoices',
    getParentRoute: () => AuthenticatedCompanyRoute,
  } as any)
const AuthenticatedCompanyCompanyCompanyIdGroupsRoute =
  AuthenticatedCompanyCompanyCompanyIdGroupsRouteImport.update({
    id: '/company/$companyId/groups',
    path: '/company/$companyId/groups',
    getParentRoute: () => AuthenticatedCompanyRoute,
  } as any)
const AuthenticatedCompanyCompanyCompanyIdDashboardRoute =
  AuthenticatedCompanyCompanyCompanyIdDashboardRouteImport.update({
    id: '/company/$companyId/dashboard',
    path: '/company/$companyId/dashboard',
    getParentRoute: () => AuthenticatedCompanyRoute,
  } as any)
const AuthenticatedCompanyCompanyCompanyIdBlockedInfluencersRoute =
  AuthenticatedCompanyCompanyCompanyIdBlockedInfluencersRouteImport.update({
    id: '/company/$companyId/blocked-influencers',
    path: '/company/$companyId/blocked-influencers',
    getParentRoute: () => AuthenticatedCompanyRoute,
  } as any)
const AuthenticatedCompanyLegacyMy_campaignsCompanyIdRoute =
  AuthenticatedCompanyLegacyMy_campaignsCompanyIdRouteImport.update({
    id: '/_legacy/my_campaigns/$companyId',
    path: '/my_campaigns/$companyId',
    getParentRoute: () => AuthenticatedCompanyRoute,
  } as any)
const AuthenticatedCompanyLegacyCompanyEditCompanyIdRoute =
  AuthenticatedCompanyLegacyCompanyEditCompanyIdRouteImport.update({
    id: '/_legacy/company-edit/$companyId',
    path: '/company-edit/$companyId',
    getParentRoute: () => AuthenticatedCompanyRoute,
  } as any)
const AuthenticatedAgencyAgencyAgencyIdMediaLibraryRoute =
  AuthenticatedAgencyAgencyAgencyIdMediaLibraryRouteImport.update({
    id: '/agency/$agencyId/media-library',
    path: '/agency/$agencyId/media-library',
    getParentRoute: () => AuthenticatedAgencyRoute,
  } as any)
const AuthenticatedAgencyAgencyAgencyIdGroupsRoute =
  AuthenticatedAgencyAgencyAgencyIdGroupsRouteImport.update({
    id: '/agency/$agencyId/groups',
    path: '/agency/$agencyId/groups',
    getParentRoute: () => AuthenticatedAgencyRoute,
  } as any)
const AuthenticatedAgencyAgencyAgencyIdEditRoute =
  AuthenticatedAgencyAgencyAgencyIdEditRouteImport.update({
    id: '/agency/$agencyId/edit',
    path: '/agency/$agencyId/edit',
    getParentRoute: () => AuthenticatedAgencyRoute,
  } as any)
const AuthenticatedAgencyAgencyAgencyIdDashboardRoute =
  AuthenticatedAgencyAgencyAgencyIdDashboardRouteImport.update({
    id: '/agency/$agencyId/dashboard',
    path: '/agency/$agencyId/dashboard',
    getParentRoute: () => AuthenticatedAgencyRoute,
  } as any)
const AuthenticatedAgencyAgencyAgencyIdCustomersRoute =
  AuthenticatedAgencyAgencyAgencyIdCustomersRouteImport.update({
    id: '/agency/$agencyId/customers',
    path: '/agency/$agencyId/customers',
    getParentRoute: () => AuthenticatedAgencyRoute,
  } as any)
const AuthenticatedAdminAdminsBoostEstimateCampaignIdRoute =
  AuthenticatedAdminAdminsBoostEstimateCampaignIdRouteImport.update({
    id: '/admins/boost-estimate/$campaignId',
    path: '/admins/boost-estimate/$campaignId',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminAdminsAgencyCreateRoute =
  AuthenticatedAdminAdminsAgencyCreateRouteImport.update({
    id: '/admins/agency/create',
    path: '/admins/agency/create',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminAdminsAccountsCombineRoute =
  AuthenticatedAdminAdminsAccountsCombineRouteImport.update({
    id: '/admins/accounts/combine',
    path: '/admins/accounts/combine',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminLegacyAgencyCreateRoute =
  AuthenticatedAdminLegacyAgencyCreateRouteImport.update({
    id: '/_legacy/agency/create',
    path: '/agency/create',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminLegacyAccountsCombineRoute =
  AuthenticatedAdminLegacyAccountsCombineRouteImport.update({
    id: '/_legacy/accounts/combine',
    path: '/accounts/combine',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedCompanyCompanyCompanyIdCampaignsStatusRoute =
  AuthenticatedCompanyCompanyCompanyIdCampaignsStatusRouteImport.update({
    id: '/company/$companyId/campaigns/$status',
    path: '/company/$companyId/campaigns/$status',
    getParentRoute: () => AuthenticatedCompanyRoute,
  } as any)
const AuthenticatedAgencyAgencyAgencyIdCampaignsStatusRoute =
  AuthenticatedAgencyAgencyAgencyIdCampaignsStatusRouteImport.update({
    id: '/agency/$agencyId/campaigns/$status',
    path: '/agency/$agencyId/campaigns/$status',
    getParentRoute: () => AuthenticatedAgencyRoute,
  } as any)
const AuthenticatedAgencyAgencyAgencyIdSubbrandCompanyIdIndexRoute =
  AuthenticatedAgencyAgencyAgencyIdSubbrandCompanyIdIndexRouteImport.update({
    id: '/agency/$agencyId/subbrand/$companyId/',
    path: '/agency/$agencyId/subbrand/$companyId/',
    getParentRoute: () => AuthenticatedAgencyRoute,
  } as any)
const AuthenticatedCompanyCompanyCompanyIdChatChar123CampaignIdChar125Char123InfluencerUserIdChar125Route =
  AuthenticatedCompanyCompanyCompanyIdChatChar123CampaignIdChar125Char123InfluencerUserIdChar125RouteImport.update(
    {
      id: '/company/$companyId/chat/{-$campaignId}/{-$influencerUserId}',
      path: '/company/$companyId/chat/{-$campaignId}/{-$influencerUserId}',
      getParentRoute: () => AuthenticatedCompanyRoute,
    } as any,
  )
const AuthenticatedAgencyAgencyAgencyIdSubbrandCompanyIdSentAmbassadorInvitesRoute =
  AuthenticatedAgencyAgencyAgencyIdSubbrandCompanyIdSentAmbassadorInvitesRouteImport.update(
    {
      id: '/agency/$agencyId/subbrand/$companyId/sent-ambassador-invites',
      path: '/agency/$agencyId/subbrand/$companyId/sent-ambassador-invites',
      getParentRoute: () => AuthenticatedAgencyRoute,
    } as any,
  )
const AuthenticatedAgencyAgencyAgencyIdSubbrandCompanyIdSearchVisibilityRoute =
  AuthenticatedAgencyAgencyAgencyIdSubbrandCompanyIdSearchVisibilityRouteImport.update(
    {
      id: '/agency/$agencyId/subbrand/$companyId/search-visibility',
      path: '/agency/$agencyId/subbrand/$companyId/search-visibility',
      getParentRoute: () => AuthenticatedAgencyRoute,
    } as any,
  )
const AuthenticatedAgencyAgencyAgencyIdSubbrandCompanyIdPendingAmbassadorsRoute =
  AuthenticatedAgencyAgencyAgencyIdSubbrandCompanyIdPendingAmbassadorsRouteImport.update(
    {
      id: '/agency/$agencyId/subbrand/$companyId/pending-ambassadors',
      path: '/agency/$agencyId/subbrand/$companyId/pending-ambassadors',
      getParentRoute: () => AuthenticatedAgencyRoute,
    } as any,
  )
const AuthenticatedAgencyAgencyAgencyIdSubbrandCompanyIdMediaLibraryRoute =
  AuthenticatedAgencyAgencyAgencyIdSubbrandCompanyIdMediaLibraryRouteImport.update(
    {
      id: '/agency/$agencyId/subbrand/$companyId/media-library',
      path: '/agency/$agencyId/subbrand/$companyId/media-library',
      getParentRoute: () => AuthenticatedAgencyRoute,
    } as any,
  )
const AuthenticatedAgencyAgencyAgencyIdSubbrandCompanyIdInvoicesRoute =
  AuthenticatedAgencyAgencyAgencyIdSubbrandCompanyIdInvoicesRouteImport.update({
    id: '/agency/$agencyId/subbrand/$companyId/invoices',
    path: '/agency/$agencyId/subbrand/$companyId/invoices',
    getParentRoute: () => AuthenticatedAgencyRoute,
  } as any)
const AuthenticatedAgencyAgencyAgencyIdSubbrandCompanyIdGroupsRoute =
  AuthenticatedAgencyAgencyAgencyIdSubbrandCompanyIdGroupsRouteImport.update({
    id: '/agency/$agencyId/subbrand/$companyId/groups',
    path: '/agency/$agencyId/subbrand/$companyId/groups',
    getParentRoute: () => AuthenticatedAgencyRoute,
  } as any)
const AuthenticatedAgencyAgencyAgencyIdSubbrandCompanyIdEditRoute =
  AuthenticatedAgencyAgencyAgencyIdSubbrandCompanyIdEditRouteImport.update({
    id: '/agency/$agencyId/subbrand/$companyId/edit',
    path: '/agency/$agencyId/subbrand/$companyId/edit',
    getParentRoute: () => AuthenticatedAgencyRoute,
  } as any)
const AuthenticatedAgencyAgencyAgencyIdSubbrandCompanyIdDashboardRoute =
  AuthenticatedAgencyAgencyAgencyIdSubbrandCompanyIdDashboardRouteImport.update(
    {
      id: '/agency/$agencyId/subbrand/$companyId/dashboard',
      path: '/agency/$agencyId/subbrand/$companyId/dashboard',
      getParentRoute: () => AuthenticatedAgencyRoute,
    } as any,
  )
const AuthenticatedAgencyAgencyAgencyIdSubbrandCompanyIdBlockedInfluencersRoute =
  AuthenticatedAgencyAgencyAgencyIdSubbrandCompanyIdBlockedInfluencersRouteImport.update(
    {
      id: '/agency/$agencyId/subbrand/$companyId/blocked-influencers',
      path: '/agency/$agencyId/subbrand/$companyId/blocked-influencers',
      getParentRoute: () => AuthenticatedAgencyRoute,
    } as any,
  )
const AuthenticatedAgencyAgencyAgencyIdSubbrandCompanyIdCampaignsStatusRoute =
  AuthenticatedAgencyAgencyAgencyIdSubbrandCompanyIdCampaignsStatusRouteImport.update(
    {
      id: '/agency/$agencyId/subbrand/$companyId/campaigns/$status',
      path: '/agency/$agencyId/subbrand/$companyId/campaigns/$status',
      getParentRoute: () => AuthenticatedAgencyRoute,
    } as any,
  )
const AuthenticatedAgencyAgencyAgencyIdChatCompanyIdChar123CampaignIdChar125Char123InfluencerUserIdChar125Route =
  AuthenticatedAgencyAgencyAgencyIdChatCompanyIdChar123CampaignIdChar125Char123InfluencerUserIdChar125RouteImport.update(
    {
      id: '/agency/$agencyId/chat/$companyId/{-$campaignId}/{-$influencerUserId}',
      path: '/agency/$agencyId/chat/$companyId/{-$campaignId}/{-$influencerUserId}',
      getParentRoute: () => AuthenticatedAgencyRoute,
    } as any,
  )

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/explore-brands': typeof ExploreBrandsRoute
  '/influencers-list': typeof InfluencersListRoute
  '/packages': typeof PackagesRoute
  '/verify-account': typeof VerifyAccountRoute
  '/verify-email-change': typeof VerifyEmailChangeRoute
  '/welcome': typeof WelcomeRoute
  '/campaigns': typeof AuthenticatedCampaignsRoute
  '/chat': typeof AuthenticatedChatRoute
  '/groups': typeof AuthenticatedGroupsRoute
  '/image-upload': typeof AuthenticatedImageUploadRoute
  '/logout': typeof AuthenticatedLogoutRoute
  '/media-library': typeof AuthenticatedMediaLibraryRoute
  '/plans': typeof AuthenticatedPlansRoute
  '/profile': typeof AuthenticatedProfileRoute
  '/search-visibility': typeof AuthenticatedSearchVisibilityRoute
  '/login': typeof UnauthenticatedLoginRoute
  '/onboarding': typeof UnauthenticatedOnboardingRoute
  '/request-reset': typeof UnauthenticatedRequestResetRoute
  '/reset-password': typeof UnauthenticatedResetPasswordRoute
  '/verify-email': typeof UnauthenticatedVerifyEmailRoute
  '/join/$slug': typeof JoinSlugRoute
  '/unsubscribe/$token': typeof UnsubscribeTokenRoute
  '/campaign-management-ongoing/$campaignId': typeof AuthenticatedCampaignManagementOngoingCampaignIdRoute
  '/campaign-management/$campaignId': typeof AuthenticatedCampaignManagementCampaignIdRoute
  '/campaign-reporting/$campaignId': typeof AuthenticatedCampaignReportingCampaignIdRoute
  '/register/agency': typeof UnauthenticatedRegisterAgencyRoute
  '/embed/join/$slug': typeof EmbedJoinSlugRoute
  '/register': typeof UnauthenticatedRegisterIndexRoute
  '/campaign/$campaignId': typeof CampaignCampaignIdIndexRoute
  '/influencer/$influencerId': typeof InfluencerInfluencerIdIndexRoute
  '/bulk-notification': typeof AuthenticatedAdminLegacyBulkNotificationRoute
  '/bulk-sms': typeof AuthenticatedAdminLegacyBulkSmsRoute
  '/customers': typeof AuthenticatedAdminLegacyCustomersRoute
  '/instagram-media-manager': typeof AuthenticatedAdminLegacyInstagramMediaManagerRoute
  '/tiktok-media-manager': typeof AuthenticatedAdminLegacyTiktokMediaManagerRoute
  '/admins/bulk-notification': typeof AuthenticatedAdminAdminsBulkNotificationRoute
  '/admins/bulk-sms': typeof AuthenticatedAdminAdminsBulkSmsRoute
  '/admins/customer-success': typeof AuthenticatedAdminAdminsCustomerSuccessRoute
  '/admins/customers': typeof AuthenticatedAdminAdminsCustomersRoute
  '/admins/hub': typeof AuthenticatedAdminAdminsHubRoute
  '/admins/impersonate': typeof AuthenticatedAdminAdminsImpersonateRoute
  '/admins/instagram-media-manager': typeof AuthenticatedAdminAdminsInstagramMediaManagerRoute
  '/admins/tiktok-media-manager': typeof AuthenticatedAdminAdminsTiktokMediaManagerRoute
  '/campaign/$campaignId/edit': typeof AuthenticatedCampaignCampaignIdEditRoute
  '/company/$companyId/edit': typeof AuthenticatedCompanyCompanyIdEditRoute
  '/company/$companyId/welcome': typeof AuthenticatedCompanyCompanyIdWelcomeRoute
  '/influencer/$influencerId/edit': typeof AuthenticatedInfluencerInfluencerIdEditRoute
  '/admins': typeof AuthenticatedAdminAdminsIndexRoute
  '/group/$groupId': typeof AuthenticatedGroupGroupIdIndexRoute
  '/accounts/combine': typeof AuthenticatedAdminLegacyAccountsCombineRoute
  '/agency/create': typeof AuthenticatedAdminLegacyAgencyCreateRoute
  '/admins/accounts/combine': typeof AuthenticatedAdminAdminsAccountsCombineRoute
  '/admins/agency/create': typeof AuthenticatedAdminAdminsAgencyCreateRoute
  '/admins/boost-estimate/$campaignId': typeof AuthenticatedAdminAdminsBoostEstimateCampaignIdRoute
  '/agency/$agencyId/customers': typeof AuthenticatedAgencyAgencyAgencyIdCustomersRoute
  '/agency/$agencyId/dashboard': typeof AuthenticatedAgencyAgencyAgencyIdDashboardRoute
  '/agency/$agencyId/edit': typeof AuthenticatedAgencyAgencyAgencyIdEditRoute
  '/agency/$agencyId/groups': typeof AuthenticatedAgencyAgencyAgencyIdGroupsRoute
  '/agency/$agencyId/media-library': typeof AuthenticatedAgencyAgencyAgencyIdMediaLibraryRoute
  '/company-edit/$companyId': typeof AuthenticatedCompanyLegacyCompanyEditCompanyIdRoute
  '/my_campaigns/$companyId': typeof AuthenticatedCompanyLegacyMy_campaignsCompanyIdRoute
  '/company/$companyId/blocked-influencers': typeof AuthenticatedCompanyCompanyCompanyIdBlockedInfluencersRoute
  '/company/$companyId/dashboard': typeof AuthenticatedCompanyCompanyCompanyIdDashboardRoute
  '/company/$companyId/groups': typeof AuthenticatedCompanyCompanyCompanyIdGroupsRoute
  '/company/$companyId/invoices': typeof AuthenticatedCompanyCompanyCompanyIdInvoicesRoute
  '/company/$companyId/media-library': typeof AuthenticatedCompanyCompanyCompanyIdMediaLibraryRoute
  '/company/$companyId/pending-ambassadors': typeof AuthenticatedCompanyCompanyCompanyIdPendingAmbassadorsRoute
  '/company/$companyId/search-visibility': typeof AuthenticatedCompanyCompanyCompanyIdSearchVisibilityRoute
  '/company/$companyId/sent-ambassador-invites': typeof AuthenticatedCompanyCompanyCompanyIdSentAmbassadorInvitesRoute
  '/admins/boost-estimate': typeof AuthenticatedAdminAdminsBoostEstimateIndexRoute
  '/agency/$agencyId': typeof AuthenticatedAgencyAgencyAgencyIdIndexRoute
  '/company/$companyId': typeof AuthenticatedCompanyCompanyCompanyIdIndexRoute
  '/agency/$agencyId/campaigns/$status': typeof AuthenticatedAgencyAgencyAgencyIdCampaignsStatusRoute
  '/company/$companyId/campaigns/$status': typeof AuthenticatedCompanyCompanyCompanyIdCampaignsStatusRoute
  '/agency/$agencyId/subbrand/$companyId/blocked-influencers': typeof AuthenticatedAgencyAgencyAgencyIdSubbrandCompanyIdBlockedInfluencersRoute
  '/agency/$agencyId/subbrand/$companyId/dashboard': typeof AuthenticatedAgencyAgencyAgencyIdSubbrandCompanyIdDashboardRoute
  '/agency/$agencyId/subbrand/$companyId/edit': typeof AuthenticatedAgencyAgencyAgencyIdSubbrandCompanyIdEditRoute
  '/agency/$agencyId/subbrand/$companyId/groups': typeof AuthenticatedAgencyAgencyAgencyIdSubbrandCompanyIdGroupsRoute
  '/agency/$agencyId/subbrand/$companyId/invoices': typeof AuthenticatedAgencyAgencyAgencyIdSubbrandCompanyIdInvoicesRoute
  '/agency/$agencyId/subbrand/$companyId/media-library': typeof AuthenticatedAgencyAgencyAgencyIdSubbrandCompanyIdMediaLibraryRoute
  '/agency/$agencyId/subbrand/$companyId/pending-ambassadors': typeof AuthenticatedAgencyAgencyAgencyIdSubbrandCompanyIdPendingAmbassadorsRoute
  '/agency/$agencyId/subbrand/$companyId/search-visibility': typeof AuthenticatedAgencyAgencyAgencyIdSubbrandCompanyIdSearchVisibilityRoute
  '/agency/$agencyId/subbrand/$companyId/sent-ambassador-invites': typeof AuthenticatedAgencyAgencyAgencyIdSubbrandCompanyIdSentAmbassadorInvitesRoute
  '/company/$companyId/chat/{-$campaignId}/{-$influencerUserId}': typeof AuthenticatedCompanyCompanyCompanyIdChatChar123CampaignIdChar125Char123InfluencerUserIdChar125Route
  '/agency/$agencyId/subbrand/$companyId': typeof AuthenticatedAgencyAgencyAgencyIdSubbrandCompanyIdIndexRoute
  '/agency/$agencyId/chat/$companyId/{-$campaignId}/{-$influencerUserId}': typeof AuthenticatedAgencyAgencyAgencyIdChatCompanyIdChar123CampaignIdChar125Char123InfluencerUserIdChar125Route
  '/agency/$agencyId/subbrand/$companyId/campaigns/$status': typeof AuthenticatedAgencyAgencyAgencyIdSubbrandCompanyIdCampaignsStatusRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/explore-brands': typeof ExploreBrandsRoute
  '/influencers-list': typeof InfluencersListRoute
  '/packages': typeof PackagesRoute
  '/verify-account': typeof VerifyAccountRoute
  '/verify-email-change': typeof VerifyEmailChangeRoute
  '/welcome': typeof WelcomeRoute
  '/campaigns': typeof AuthenticatedCampaignsRoute
  '/chat': typeof AuthenticatedChatRoute
  '/groups': typeof AuthenticatedGroupsRoute
  '/image-upload': typeof AuthenticatedImageUploadRoute
  '/logout': typeof AuthenticatedLogoutRoute
  '/media-library': typeof AuthenticatedMediaLibraryRoute
  '/plans': typeof AuthenticatedPlansRoute
  '/profile': typeof AuthenticatedProfileRoute
  '/search-visibility': typeof AuthenticatedSearchVisibilityRoute
  '/login': typeof UnauthenticatedLoginRoute
  '/onboarding': typeof UnauthenticatedOnboardingRoute
  '/request-reset': typeof UnauthenticatedRequestResetRoute
  '/reset-password': typeof UnauthenticatedResetPasswordRoute
  '/verify-email': typeof UnauthenticatedVerifyEmailRoute
  '/join/$slug': typeof JoinSlugRoute
  '/unsubscribe/$token': typeof UnsubscribeTokenRoute
  '/campaign-management-ongoing/$campaignId': typeof AuthenticatedCampaignManagementOngoingCampaignIdRoute
  '/campaign-management/$campaignId': typeof AuthenticatedCampaignManagementCampaignIdRoute
  '/campaign-reporting/$campaignId': typeof AuthenticatedCampaignReportingCampaignIdRoute
  '/register/agency': typeof UnauthenticatedRegisterAgencyRoute
  '/embed/join/$slug': typeof EmbedJoinSlugRoute
  '/register': typeof UnauthenticatedRegisterIndexRoute
  '/campaign/$campaignId': typeof CampaignCampaignIdIndexRoute
  '/influencer/$influencerId': typeof InfluencerInfluencerIdIndexRoute
  '/bulk-notification': typeof AuthenticatedAdminLegacyBulkNotificationRoute
  '/bulk-sms': typeof AuthenticatedAdminLegacyBulkSmsRoute
  '/customers': typeof AuthenticatedAdminLegacyCustomersRoute
  '/instagram-media-manager': typeof AuthenticatedAdminLegacyInstagramMediaManagerRoute
  '/tiktok-media-manager': typeof AuthenticatedAdminLegacyTiktokMediaManagerRoute
  '/admins/bulk-notification': typeof AuthenticatedAdminAdminsBulkNotificationRoute
  '/admins/bulk-sms': typeof AuthenticatedAdminAdminsBulkSmsRoute
  '/admins/customer-success': typeof AuthenticatedAdminAdminsCustomerSuccessRoute
  '/admins/customers': typeof AuthenticatedAdminAdminsCustomersRoute
  '/admins/hub': typeof AuthenticatedAdminAdminsHubRoute
  '/admins/impersonate': typeof AuthenticatedAdminAdminsImpersonateRoute
  '/admins/instagram-media-manager': typeof AuthenticatedAdminAdminsInstagramMediaManagerRoute
  '/admins/tiktok-media-manager': typeof AuthenticatedAdminAdminsTiktokMediaManagerRoute
  '/campaign/$campaignId/edit': typeof AuthenticatedCampaignCampaignIdEditRoute
  '/company/$companyId/edit': typeof AuthenticatedCompanyCompanyIdEditRoute
  '/company/$companyId/welcome': typeof AuthenticatedCompanyCompanyIdWelcomeRoute
  '/influencer/$influencerId/edit': typeof AuthenticatedInfluencerInfluencerIdEditRoute
  '/admins': typeof AuthenticatedAdminAdminsIndexRoute
  '/group/$groupId': typeof AuthenticatedGroupGroupIdIndexRoute
  '/accounts/combine': typeof AuthenticatedAdminLegacyAccountsCombineRoute
  '/agency/create': typeof AuthenticatedAdminLegacyAgencyCreateRoute
  '/admins/accounts/combine': typeof AuthenticatedAdminAdminsAccountsCombineRoute
  '/admins/agency/create': typeof AuthenticatedAdminAdminsAgencyCreateRoute
  '/admins/boost-estimate/$campaignId': typeof AuthenticatedAdminAdminsBoostEstimateCampaignIdRoute
  '/agency/$agencyId/customers': typeof AuthenticatedAgencyAgencyAgencyIdCustomersRoute
  '/agency/$agencyId/dashboard': typeof AuthenticatedAgencyAgencyAgencyIdDashboardRoute
  '/agency/$agencyId/edit': typeof AuthenticatedAgencyAgencyAgencyIdEditRoute
  '/agency/$agencyId/groups': typeof AuthenticatedAgencyAgencyAgencyIdGroupsRoute
  '/agency/$agencyId/media-library': typeof AuthenticatedAgencyAgencyAgencyIdMediaLibraryRoute
  '/company-edit/$companyId': typeof AuthenticatedCompanyLegacyCompanyEditCompanyIdRoute
  '/my_campaigns/$companyId': typeof AuthenticatedCompanyLegacyMy_campaignsCompanyIdRoute
  '/company/$companyId/blocked-influencers': typeof AuthenticatedCompanyCompanyCompanyIdBlockedInfluencersRoute
  '/company/$companyId/dashboard': typeof AuthenticatedCompanyCompanyCompanyIdDashboardRoute
  '/company/$companyId/groups': typeof AuthenticatedCompanyCompanyCompanyIdGroupsRoute
  '/company/$companyId/invoices': typeof AuthenticatedCompanyCompanyCompanyIdInvoicesRoute
  '/company/$companyId/media-library': typeof AuthenticatedCompanyCompanyCompanyIdMediaLibraryRoute
  '/company/$companyId/pending-ambassadors': typeof AuthenticatedCompanyCompanyCompanyIdPendingAmbassadorsRoute
  '/company/$companyId/search-visibility': typeof AuthenticatedCompanyCompanyCompanyIdSearchVisibilityRoute
  '/company/$companyId/sent-ambassador-invites': typeof AuthenticatedCompanyCompanyCompanyIdSentAmbassadorInvitesRoute
  '/admins/boost-estimate': typeof AuthenticatedAdminAdminsBoostEstimateIndexRoute
  '/agency/$agencyId': typeof AuthenticatedAgencyAgencyAgencyIdIndexRoute
  '/company/$companyId': typeof AuthenticatedCompanyCompanyCompanyIdIndexRoute
  '/agency/$agencyId/campaigns/$status': typeof AuthenticatedAgencyAgencyAgencyIdCampaignsStatusRoute
  '/company/$companyId/campaigns/$status': typeof AuthenticatedCompanyCompanyCompanyIdCampaignsStatusRoute
  '/agency/$agencyId/subbrand/$companyId/blocked-influencers': typeof AuthenticatedAgencyAgencyAgencyIdSubbrandCompanyIdBlockedInfluencersRoute
  '/agency/$agencyId/subbrand/$companyId/dashboard': typeof AuthenticatedAgencyAgencyAgencyIdSubbrandCompanyIdDashboardRoute
  '/agency/$agencyId/subbrand/$companyId/edit': typeof AuthenticatedAgencyAgencyAgencyIdSubbrandCompanyIdEditRoute
  '/agency/$agencyId/subbrand/$companyId/groups': typeof AuthenticatedAgencyAgencyAgencyIdSubbrandCompanyIdGroupsRoute
  '/agency/$agencyId/subbrand/$companyId/invoices': typeof AuthenticatedAgencyAgencyAgencyIdSubbrandCompanyIdInvoicesRoute
  '/agency/$agencyId/subbrand/$companyId/media-library': typeof AuthenticatedAgencyAgencyAgencyIdSubbrandCompanyIdMediaLibraryRoute
  '/agency/$agencyId/subbrand/$companyId/pending-ambassadors': typeof AuthenticatedAgencyAgencyAgencyIdSubbrandCompanyIdPendingAmbassadorsRoute
  '/agency/$agencyId/subbrand/$companyId/search-visibility': typeof AuthenticatedAgencyAgencyAgencyIdSubbrandCompanyIdSearchVisibilityRoute
  '/agency/$agencyId/subbrand/$companyId/sent-ambassador-invites': typeof AuthenticatedAgencyAgencyAgencyIdSubbrandCompanyIdSentAmbassadorInvitesRoute
  '/company/$companyId/chat/{-$campaignId}/{-$influencerUserId}': typeof AuthenticatedCompanyCompanyCompanyIdChatChar123CampaignIdChar125Char123InfluencerUserIdChar125Route
  '/agency/$agencyId/subbrand/$companyId': typeof AuthenticatedAgencyAgencyAgencyIdSubbrandCompanyIdIndexRoute
  '/agency/$agencyId/chat/$companyId/{-$campaignId}/{-$influencerUserId}': typeof AuthenticatedAgencyAgencyAgencyIdChatCompanyIdChar123CampaignIdChar125Char123InfluencerUserIdChar125Route
  '/agency/$agencyId/subbrand/$companyId/campaigns/$status': typeof AuthenticatedAgencyAgencyAgencyIdSubbrandCompanyIdCampaignsStatusRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/_unauthenticated': typeof UnauthenticatedRouteWithChildren
  '/explore-brands': typeof ExploreBrandsRoute
  '/influencers-list': typeof InfluencersListRoute
  '/packages': typeof PackagesRoute
  '/verify-account': typeof VerifyAccountRoute
  '/verify-email-change': typeof VerifyEmailChangeRoute
  '/welcome': typeof WelcomeRoute
  '/_authenticated/_admin': typeof AuthenticatedAdminRouteWithChildren
  '/_authenticated/_agency': typeof AuthenticatedAgencyRouteWithChildren
  '/_authenticated/_company': typeof AuthenticatedCompanyRouteWithChildren
  '/_authenticated/campaigns': typeof AuthenticatedCampaignsRoute
  '/_authenticated/chat': typeof AuthenticatedChatRoute
  '/_authenticated/groups': typeof AuthenticatedGroupsRoute
  '/_authenticated/image-upload': typeof AuthenticatedImageUploadRoute
  '/_authenticated/logout': typeof AuthenticatedLogoutRoute
  '/_authenticated/media-library': typeof AuthenticatedMediaLibraryRoute
  '/_authenticated/plans': typeof AuthenticatedPlansRoute
  '/_authenticated/profile': typeof AuthenticatedProfileRoute
  '/_authenticated/search-visibility': typeof AuthenticatedSearchVisibilityRoute
  '/_unauthenticated/login': typeof UnauthenticatedLoginRoute
  '/_unauthenticated/onboarding': typeof UnauthenticatedOnboardingRoute
  '/_unauthenticated/request-reset': typeof UnauthenticatedRequestResetRoute
  '/_unauthenticated/reset-password': typeof UnauthenticatedResetPasswordRoute
  '/_unauthenticated/verify-email': typeof UnauthenticatedVerifyEmailRoute
  '/join/$slug': typeof JoinSlugRoute
  '/unsubscribe/$token': typeof UnsubscribeTokenRoute
  '/_authenticated/campaign-management-ongoing/$campaignId': typeof AuthenticatedCampaignManagementOngoingCampaignIdRoute
  '/_authenticated/campaign-management/$campaignId': typeof AuthenticatedCampaignManagementCampaignIdRoute
  '/_authenticated/campaign-reporting/$campaignId': typeof AuthenticatedCampaignReportingCampaignIdRoute
  '/_unauthenticated/register/agency': typeof UnauthenticatedRegisterAgencyRoute
  '/embed/join/$slug': typeof EmbedJoinSlugRoute
  '/_unauthenticated/register/': typeof UnauthenticatedRegisterIndexRoute
  '/campaign/$campaignId/': typeof CampaignCampaignIdIndexRoute
  '/influencer/$influencerId/': typeof InfluencerInfluencerIdIndexRoute
  '/_authenticated/_admin/_legacy/bulk-notification': typeof AuthenticatedAdminLegacyBulkNotificationRoute
  '/_authenticated/_admin/_legacy/bulk-sms': typeof AuthenticatedAdminLegacyBulkSmsRoute
  '/_authenticated/_admin/_legacy/customers': typeof AuthenticatedAdminLegacyCustomersRoute
  '/_authenticated/_admin/_legacy/instagram-media-manager': typeof AuthenticatedAdminLegacyInstagramMediaManagerRoute
  '/_authenticated/_admin/_legacy/tiktok-media-manager': typeof AuthenticatedAdminLegacyTiktokMediaManagerRoute
  '/_authenticated/_admin/admins/bulk-notification': typeof AuthenticatedAdminAdminsBulkNotificationRoute
  '/_authenticated/_admin/admins/bulk-sms': typeof AuthenticatedAdminAdminsBulkSmsRoute
  '/_authenticated/_admin/admins/customer-success': typeof AuthenticatedAdminAdminsCustomerSuccessRoute
  '/_authenticated/_admin/admins/customers': typeof AuthenticatedAdminAdminsCustomersRoute
  '/_authenticated/_admin/admins/hub': typeof AuthenticatedAdminAdminsHubRoute
  '/_authenticated/_admin/admins/impersonate': typeof AuthenticatedAdminAdminsImpersonateRoute
  '/_authenticated/_admin/admins/instagram-media-manager': typeof AuthenticatedAdminAdminsInstagramMediaManagerRoute
  '/_authenticated/_admin/admins/tiktok-media-manager': typeof AuthenticatedAdminAdminsTiktokMediaManagerRoute
  '/_authenticated/campaign/$campaignId/edit': typeof AuthenticatedCampaignCampaignIdEditRoute
  '/_authenticated/company/$companyId/edit': typeof AuthenticatedCompanyCompanyIdEditRoute
  '/_authenticated/company/$companyId/welcome': typeof AuthenticatedCompanyCompanyIdWelcomeRoute
  '/_authenticated/influencer/$influencerId/edit': typeof AuthenticatedInfluencerInfluencerIdEditRoute
  '/_authenticated/_admin/admins/': typeof AuthenticatedAdminAdminsIndexRoute
  '/_authenticated/group/$groupId/': typeof AuthenticatedGroupGroupIdIndexRoute
  '/_authenticated/_admin/_legacy/accounts/combine': typeof AuthenticatedAdminLegacyAccountsCombineRoute
  '/_authenticated/_admin/_legacy/agency/create': typeof AuthenticatedAdminLegacyAgencyCreateRoute
  '/_authenticated/_admin/admins/accounts/combine': typeof AuthenticatedAdminAdminsAccountsCombineRoute
  '/_authenticated/_admin/admins/agency/create': typeof AuthenticatedAdminAdminsAgencyCreateRoute
  '/_authenticated/_admin/admins/boost-estimate/$campaignId': typeof AuthenticatedAdminAdminsBoostEstimateCampaignIdRoute
  '/_authenticated/_agency/agency/$agencyId/customers': typeof AuthenticatedAgencyAgencyAgencyIdCustomersRoute
  '/_authenticated/_agency/agency/$agencyId/dashboard': typeof AuthenticatedAgencyAgencyAgencyIdDashboardRoute
  '/_authenticated/_agency/agency/$agencyId/edit': typeof AuthenticatedAgencyAgencyAgencyIdEditRoute
  '/_authenticated/_agency/agency/$agencyId/groups': typeof AuthenticatedAgencyAgencyAgencyIdGroupsRoute
  '/_authenticated/_agency/agency/$agencyId/media-library': typeof AuthenticatedAgencyAgencyAgencyIdMediaLibraryRoute
  '/_authenticated/_company/_legacy/company-edit/$companyId': typeof AuthenticatedCompanyLegacyCompanyEditCompanyIdRoute
  '/_authenticated/_company/_legacy/my_campaigns/$companyId': typeof AuthenticatedCompanyLegacyMy_campaignsCompanyIdRoute
  '/_authenticated/_company/company/$companyId/blocked-influencers': typeof AuthenticatedCompanyCompanyCompanyIdBlockedInfluencersRoute
  '/_authenticated/_company/company/$companyId/dashboard': typeof AuthenticatedCompanyCompanyCompanyIdDashboardRoute
  '/_authenticated/_company/company/$companyId/groups': typeof AuthenticatedCompanyCompanyCompanyIdGroupsRoute
  '/_authenticated/_company/company/$companyId/invoices': typeof AuthenticatedCompanyCompanyCompanyIdInvoicesRoute
  '/_authenticated/_company/company/$companyId/media-library': typeof AuthenticatedCompanyCompanyCompanyIdMediaLibraryRoute
  '/_authenticated/_company/company/$companyId/pending-ambassadors': typeof AuthenticatedCompanyCompanyCompanyIdPendingAmbassadorsRoute
  '/_authenticated/_company/company/$companyId/search-visibility': typeof AuthenticatedCompanyCompanyCompanyIdSearchVisibilityRoute
  '/_authenticated/_company/company/$companyId/sent-ambassador-invites': typeof AuthenticatedCompanyCompanyCompanyIdSentAmbassadorInvitesRoute
  '/_authenticated/_admin/admins/boost-estimate/': typeof AuthenticatedAdminAdminsBoostEstimateIndexRoute
  '/_authenticated/_agency/agency/$agencyId/': typeof AuthenticatedAgencyAgencyAgencyIdIndexRoute
  '/_authenticated/_company/company/$companyId/': typeof AuthenticatedCompanyCompanyCompanyIdIndexRoute
  '/_authenticated/_agency/agency/$agencyId/campaigns/$status': typeof AuthenticatedAgencyAgencyAgencyIdCampaignsStatusRoute
  '/_authenticated/_company/company/$companyId/campaigns/$status': typeof AuthenticatedCompanyCompanyCompanyIdCampaignsStatusRoute
  '/_authenticated/_agency/agency/$agencyId/subbrand/$companyId/blocked-influencers': typeof AuthenticatedAgencyAgencyAgencyIdSubbrandCompanyIdBlockedInfluencersRoute
  '/_authenticated/_agency/agency/$agencyId/subbrand/$companyId/dashboard': typeof AuthenticatedAgencyAgencyAgencyIdSubbrandCompanyIdDashboardRoute
  '/_authenticated/_agency/agency/$agencyId/subbrand/$companyId/edit': typeof AuthenticatedAgencyAgencyAgencyIdSubbrandCompanyIdEditRoute
  '/_authenticated/_agency/agency/$agencyId/subbrand/$companyId/groups': typeof AuthenticatedAgencyAgencyAgencyIdSubbrandCompanyIdGroupsRoute
  '/_authenticated/_agency/agency/$agencyId/subbrand/$companyId/invoices': typeof AuthenticatedAgencyAgencyAgencyIdSubbrandCompanyIdInvoicesRoute
  '/_authenticated/_agency/agency/$agencyId/subbrand/$companyId/media-library': typeof AuthenticatedAgencyAgencyAgencyIdSubbrandCompanyIdMediaLibraryRoute
  '/_authenticated/_agency/agency/$agencyId/subbrand/$companyId/pending-ambassadors': typeof AuthenticatedAgencyAgencyAgencyIdSubbrandCompanyIdPendingAmbassadorsRoute
  '/_authenticated/_agency/agency/$agencyId/subbrand/$companyId/search-visibility': typeof AuthenticatedAgencyAgencyAgencyIdSubbrandCompanyIdSearchVisibilityRoute
  '/_authenticated/_agency/agency/$agencyId/subbrand/$companyId/sent-ambassador-invites': typeof AuthenticatedAgencyAgencyAgencyIdSubbrandCompanyIdSentAmbassadorInvitesRoute
  '/_authenticated/_company/company/$companyId/chat/{-$campaignId}/{-$influencerUserId}': typeof AuthenticatedCompanyCompanyCompanyIdChatChar123CampaignIdChar125Char123InfluencerUserIdChar125Route
  '/_authenticated/_agency/agency/$agencyId/subbrand/$companyId/': typeof AuthenticatedAgencyAgencyAgencyIdSubbrandCompanyIdIndexRoute
  '/_authenticated/_agency/agency/$agencyId/chat/$companyId/{-$campaignId}/{-$influencerUserId}': typeof AuthenticatedAgencyAgencyAgencyIdChatCompanyIdChar123CampaignIdChar125Char123InfluencerUserIdChar125Route
  '/_authenticated/_agency/agency/$agencyId/subbrand/$companyId/campaigns/$status': typeof AuthenticatedAgencyAgencyAgencyIdSubbrandCompanyIdCampaignsStatusRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/explore-brands'
    | '/influencers-list'
    | '/packages'
    | '/verify-account'
    | '/verify-email-change'
    | '/welcome'
    | '/campaigns'
    | '/chat'
    | '/groups'
    | '/image-upload'
    | '/logout'
    | '/media-library'
    | '/plans'
    | '/profile'
    | '/search-visibility'
    | '/login'
    | '/onboarding'
    | '/request-reset'
    | '/reset-password'
    | '/verify-email'
    | '/join/$slug'
    | '/unsubscribe/$token'
    | '/campaign-management-ongoing/$campaignId'
    | '/campaign-management/$campaignId'
    | '/campaign-reporting/$campaignId'
    | '/register/agency'
    | '/embed/join/$slug'
    | '/register'
    | '/campaign/$campaignId'
    | '/influencer/$influencerId'
    | '/bulk-notification'
    | '/bulk-sms'
    | '/customers'
    | '/instagram-media-manager'
    | '/tiktok-media-manager'
    | '/admins/bulk-notification'
    | '/admins/bulk-sms'
    | '/admins/customer-success'
    | '/admins/customers'
    | '/admins/hub'
    | '/admins/impersonate'
    | '/admins/instagram-media-manager'
    | '/admins/tiktok-media-manager'
    | '/campaign/$campaignId/edit'
    | '/company/$companyId/edit'
    | '/company/$companyId/welcome'
    | '/influencer/$influencerId/edit'
    | '/admins'
    | '/group/$groupId'
    | '/accounts/combine'
    | '/agency/create'
    | '/admins/accounts/combine'
    | '/admins/agency/create'
    | '/admins/boost-estimate/$campaignId'
    | '/agency/$agencyId/customers'
    | '/agency/$agencyId/dashboard'
    | '/agency/$agencyId/edit'
    | '/agency/$agencyId/groups'
    | '/agency/$agencyId/media-library'
    | '/company-edit/$companyId'
    | '/my_campaigns/$companyId'
    | '/company/$companyId/blocked-influencers'
    | '/company/$companyId/dashboard'
    | '/company/$companyId/groups'
    | '/company/$companyId/invoices'
    | '/company/$companyId/media-library'
    | '/company/$companyId/pending-ambassadors'
    | '/company/$companyId/search-visibility'
    | '/company/$companyId/sent-ambassador-invites'
    | '/admins/boost-estimate'
    | '/agency/$agencyId'
    | '/company/$companyId'
    | '/agency/$agencyId/campaigns/$status'
    | '/company/$companyId/campaigns/$status'
    | '/agency/$agencyId/subbrand/$companyId/blocked-influencers'
    | '/agency/$agencyId/subbrand/$companyId/dashboard'
    | '/agency/$agencyId/subbrand/$companyId/edit'
    | '/agency/$agencyId/subbrand/$companyId/groups'
    | '/agency/$agencyId/subbrand/$companyId/invoices'
    | '/agency/$agencyId/subbrand/$companyId/media-library'
    | '/agency/$agencyId/subbrand/$companyId/pending-ambassadors'
    | '/agency/$agencyId/subbrand/$companyId/search-visibility'
    | '/agency/$agencyId/subbrand/$companyId/sent-ambassador-invites'
    | '/company/$companyId/chat/{-$campaignId}/{-$influencerUserId}'
    | '/agency/$agencyId/subbrand/$companyId'
    | '/agency/$agencyId/chat/$companyId/{-$campaignId}/{-$influencerUserId}'
    | '/agency/$agencyId/subbrand/$companyId/campaigns/$status'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/explore-brands'
    | '/influencers-list'
    | '/packages'
    | '/verify-account'
    | '/verify-email-change'
    | '/welcome'
    | '/campaigns'
    | '/chat'
    | '/groups'
    | '/image-upload'
    | '/logout'
    | '/media-library'
    | '/plans'
    | '/profile'
    | '/search-visibility'
    | '/login'
    | '/onboarding'
    | '/request-reset'
    | '/reset-password'
    | '/verify-email'
    | '/join/$slug'
    | '/unsubscribe/$token'
    | '/campaign-management-ongoing/$campaignId'
    | '/campaign-management/$campaignId'
    | '/campaign-reporting/$campaignId'
    | '/register/agency'
    | '/embed/join/$slug'
    | '/register'
    | '/campaign/$campaignId'
    | '/influencer/$influencerId'
    | '/bulk-notification'
    | '/bulk-sms'
    | '/customers'
    | '/instagram-media-manager'
    | '/tiktok-media-manager'
    | '/admins/bulk-notification'
    | '/admins/bulk-sms'
    | '/admins/customer-success'
    | '/admins/customers'
    | '/admins/hub'
    | '/admins/impersonate'
    | '/admins/instagram-media-manager'
    | '/admins/tiktok-media-manager'
    | '/campaign/$campaignId/edit'
    | '/company/$companyId/edit'
    | '/company/$companyId/welcome'
    | '/influencer/$influencerId/edit'
    | '/admins'
    | '/group/$groupId'
    | '/accounts/combine'
    | '/agency/create'
    | '/admins/accounts/combine'
    | '/admins/agency/create'
    | '/admins/boost-estimate/$campaignId'
    | '/agency/$agencyId/customers'
    | '/agency/$agencyId/dashboard'
    | '/agency/$agencyId/edit'
    | '/agency/$agencyId/groups'
    | '/agency/$agencyId/media-library'
    | '/company-edit/$companyId'
    | '/my_campaigns/$companyId'
    | '/company/$companyId/blocked-influencers'
    | '/company/$companyId/dashboard'
    | '/company/$companyId/groups'
    | '/company/$companyId/invoices'
    | '/company/$companyId/media-library'
    | '/company/$companyId/pending-ambassadors'
    | '/company/$companyId/search-visibility'
    | '/company/$companyId/sent-ambassador-invites'
    | '/admins/boost-estimate'
    | '/agency/$agencyId'
    | '/company/$companyId'
    | '/agency/$agencyId/campaigns/$status'
    | '/company/$companyId/campaigns/$status'
    | '/agency/$agencyId/subbrand/$companyId/blocked-influencers'
    | '/agency/$agencyId/subbrand/$companyId/dashboard'
    | '/agency/$agencyId/subbrand/$companyId/edit'
    | '/agency/$agencyId/subbrand/$companyId/groups'
    | '/agency/$agencyId/subbrand/$companyId/invoices'
    | '/agency/$agencyId/subbrand/$companyId/media-library'
    | '/agency/$agencyId/subbrand/$companyId/pending-ambassadors'
    | '/agency/$agencyId/subbrand/$companyId/search-visibility'
    | '/agency/$agencyId/subbrand/$companyId/sent-ambassador-invites'
    | '/company/$companyId/chat/{-$campaignId}/{-$influencerUserId}'
    | '/agency/$agencyId/subbrand/$companyId'
    | '/agency/$agencyId/chat/$companyId/{-$campaignId}/{-$influencerUserId}'
    | '/agency/$agencyId/subbrand/$companyId/campaigns/$status'
  id:
    | '__root__'
    | '/'
    | '/_authenticated'
    | '/_unauthenticated'
    | '/explore-brands'
    | '/influencers-list'
    | '/packages'
    | '/verify-account'
    | '/verify-email-change'
    | '/welcome'
    | '/_authenticated/_admin'
    | '/_authenticated/_agency'
    | '/_authenticated/_company'
    | '/_authenticated/campaigns'
    | '/_authenticated/chat'
    | '/_authenticated/groups'
    | '/_authenticated/image-upload'
    | '/_authenticated/logout'
    | '/_authenticated/media-library'
    | '/_authenticated/plans'
    | '/_authenticated/profile'
    | '/_authenticated/search-visibility'
    | '/_unauthenticated/login'
    | '/_unauthenticated/onboarding'
    | '/_unauthenticated/request-reset'
    | '/_unauthenticated/reset-password'
    | '/_unauthenticated/verify-email'
    | '/join/$slug'
    | '/unsubscribe/$token'
    | '/_authenticated/campaign-management-ongoing/$campaignId'
    | '/_authenticated/campaign-management/$campaignId'
    | '/_authenticated/campaign-reporting/$campaignId'
    | '/_unauthenticated/register/agency'
    | '/embed/join/$slug'
    | '/_unauthenticated/register/'
    | '/campaign/$campaignId/'
    | '/influencer/$influencerId/'
    | '/_authenticated/_admin/_legacy/bulk-notification'
    | '/_authenticated/_admin/_legacy/bulk-sms'
    | '/_authenticated/_admin/_legacy/customers'
    | '/_authenticated/_admin/_legacy/instagram-media-manager'
    | '/_authenticated/_admin/_legacy/tiktok-media-manager'
    | '/_authenticated/_admin/admins/bulk-notification'
    | '/_authenticated/_admin/admins/bulk-sms'
    | '/_authenticated/_admin/admins/customer-success'
    | '/_authenticated/_admin/admins/customers'
    | '/_authenticated/_admin/admins/hub'
    | '/_authenticated/_admin/admins/impersonate'
    | '/_authenticated/_admin/admins/instagram-media-manager'
    | '/_authenticated/_admin/admins/tiktok-media-manager'
    | '/_authenticated/campaign/$campaignId/edit'
    | '/_authenticated/company/$companyId/edit'
    | '/_authenticated/company/$companyId/welcome'
    | '/_authenticated/influencer/$influencerId/edit'
    | '/_authenticated/_admin/admins/'
    | '/_authenticated/group/$groupId/'
    | '/_authenticated/_admin/_legacy/accounts/combine'
    | '/_authenticated/_admin/_legacy/agency/create'
    | '/_authenticated/_admin/admins/accounts/combine'
    | '/_authenticated/_admin/admins/agency/create'
    | '/_authenticated/_admin/admins/boost-estimate/$campaignId'
    | '/_authenticated/_agency/agency/$agencyId/customers'
    | '/_authenticated/_agency/agency/$agencyId/dashboard'
    | '/_authenticated/_agency/agency/$agencyId/edit'
    | '/_authenticated/_agency/agency/$agencyId/groups'
    | '/_authenticated/_agency/agency/$agencyId/media-library'
    | '/_authenticated/_company/_legacy/company-edit/$companyId'
    | '/_authenticated/_company/_legacy/my_campaigns/$companyId'
    | '/_authenticated/_company/company/$companyId/blocked-influencers'
    | '/_authenticated/_company/company/$companyId/dashboard'
    | '/_authenticated/_company/company/$companyId/groups'
    | '/_authenticated/_company/company/$companyId/invoices'
    | '/_authenticated/_company/company/$companyId/media-library'
    | '/_authenticated/_company/company/$companyId/pending-ambassadors'
    | '/_authenticated/_company/company/$companyId/search-visibility'
    | '/_authenticated/_company/company/$companyId/sent-ambassador-invites'
    | '/_authenticated/_admin/admins/boost-estimate/'
    | '/_authenticated/_agency/agency/$agencyId/'
    | '/_authenticated/_company/company/$companyId/'
    | '/_authenticated/_agency/agency/$agencyId/campaigns/$status'
    | '/_authenticated/_company/company/$companyId/campaigns/$status'
    | '/_authenticated/_agency/agency/$agencyId/subbrand/$companyId/blocked-influencers'
    | '/_authenticated/_agency/agency/$agencyId/subbrand/$companyId/dashboard'
    | '/_authenticated/_agency/agency/$agencyId/subbrand/$companyId/edit'
    | '/_authenticated/_agency/agency/$agencyId/subbrand/$companyId/groups'
    | '/_authenticated/_agency/agency/$agencyId/subbrand/$companyId/invoices'
    | '/_authenticated/_agency/agency/$agencyId/subbrand/$companyId/media-library'
    | '/_authenticated/_agency/agency/$agencyId/subbrand/$companyId/pending-ambassadors'
    | '/_authenticated/_agency/agency/$agencyId/subbrand/$companyId/search-visibility'
    | '/_authenticated/_agency/agency/$agencyId/subbrand/$companyId/sent-ambassador-invites'
    | '/_authenticated/_company/company/$companyId/chat/{-$campaignId}/{-$influencerUserId}'
    | '/_authenticated/_agency/agency/$agencyId/subbrand/$companyId/'
    | '/_authenticated/_agency/agency/$agencyId/chat/$companyId/{-$campaignId}/{-$influencerUserId}'
    | '/_authenticated/_agency/agency/$agencyId/subbrand/$companyId/campaigns/$status'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  UnauthenticatedRoute: typeof UnauthenticatedRouteWithChildren
  ExploreBrandsRoute: typeof ExploreBrandsRoute
  InfluencersListRoute: typeof InfluencersListRoute
  PackagesRoute: typeof PackagesRoute
  VerifyAccountRoute: typeof VerifyAccountRoute
  VerifyEmailChangeRoute: typeof VerifyEmailChangeRoute
  WelcomeRoute: typeof WelcomeRoute
  JoinSlugRoute: typeof JoinSlugRoute
  UnsubscribeTokenRoute: typeof UnsubscribeTokenRoute
  EmbedJoinSlugRoute: typeof EmbedJoinSlugRoute
  CampaignCampaignIdIndexRoute: typeof CampaignCampaignIdIndexRoute
  InfluencerInfluencerIdIndexRoute: typeof InfluencerInfluencerIdIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/welcome': {
      id: '/welcome'
      path: '/welcome'
      fullPath: '/welcome'
      preLoaderRoute: typeof WelcomeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/verify-email-change': {
      id: '/verify-email-change'
      path: '/verify-email-change'
      fullPath: '/verify-email-change'
      preLoaderRoute: typeof VerifyEmailChangeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/verify-account': {
      id: '/verify-account'
      path: '/verify-account'
      fullPath: '/verify-account'
      preLoaderRoute: typeof VerifyAccountRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/packages': {
      id: '/packages'
      path: '/packages'
      fullPath: '/packages'
      preLoaderRoute: typeof PackagesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/influencers-list': {
      id: '/influencers-list'
      path: '/influencers-list'
      fullPath: '/influencers-list'
      preLoaderRoute: typeof InfluencersListRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/explore-brands': {
      id: '/explore-brands'
      path: '/explore-brands'
      fullPath: '/explore-brands'
      preLoaderRoute: typeof ExploreBrandsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_unauthenticated': {
      id: '/_unauthenticated'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof UnauthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/unsubscribe/$token': {
      id: '/unsubscribe/$token'
      path: '/unsubscribe/$token'
      fullPath: '/unsubscribe/$token'
      preLoaderRoute: typeof UnsubscribeTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/join/$slug': {
      id: '/join/$slug'
      path: '/join/$slug'
      fullPath: '/join/$slug'
      preLoaderRoute: typeof JoinSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_unauthenticated/verify-email': {
      id: '/_unauthenticated/verify-email'
      path: '/verify-email'
      fullPath: '/verify-email'
      preLoaderRoute: typeof UnauthenticatedVerifyEmailRouteImport
      parentRoute: typeof UnauthenticatedRoute
    }
    '/_unauthenticated/reset-password': {
      id: '/_unauthenticated/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof UnauthenticatedResetPasswordRouteImport
      parentRoute: typeof UnauthenticatedRoute
    }
    '/_unauthenticated/request-reset': {
      id: '/_unauthenticated/request-reset'
      path: '/request-reset'
      fullPath: '/request-reset'
      preLoaderRoute: typeof UnauthenticatedRequestResetRouteImport
      parentRoute: typeof UnauthenticatedRoute
    }
    '/_unauthenticated/onboarding': {
      id: '/_unauthenticated/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof UnauthenticatedOnboardingRouteImport
      parentRoute: typeof UnauthenticatedRoute
    }
    '/_unauthenticated/login': {
      id: '/_unauthenticated/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof UnauthenticatedLoginRouteImport
      parentRoute: typeof UnauthenticatedRoute
    }
    '/_authenticated/search-visibility': {
      id: '/_authenticated/search-visibility'
      path: '/search-visibility'
      fullPath: '/search-visibility'
      preLoaderRoute: typeof AuthenticatedSearchVisibilityRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/profile': {
      id: '/_authenticated/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof AuthenticatedProfileRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/plans': {
      id: '/_authenticated/plans'
      path: '/plans'
      fullPath: '/plans'
      preLoaderRoute: typeof AuthenticatedPlansRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/media-library': {
      id: '/_authenticated/media-library'
      path: '/media-library'
      fullPath: '/media-library'
      preLoaderRoute: typeof AuthenticatedMediaLibraryRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/logout': {
      id: '/_authenticated/logout'
      path: '/logout'
      fullPath: '/logout'
      preLoaderRoute: typeof AuthenticatedLogoutRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/image-upload': {
      id: '/_authenticated/image-upload'
      path: '/image-upload'
      fullPath: '/image-upload'
      preLoaderRoute: typeof AuthenticatedImageUploadRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/groups': {
      id: '/_authenticated/groups'
      path: '/groups'
      fullPath: '/groups'
      preLoaderRoute: typeof AuthenticatedGroupsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/chat': {
      id: '/_authenticated/chat'
      path: '/chat'
      fullPath: '/chat'
      preLoaderRoute: typeof AuthenticatedChatRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/campaigns': {
      id: '/_authenticated/campaigns'
      path: '/campaigns'
      fullPath: '/campaigns'
      preLoaderRoute: typeof AuthenticatedCampaignsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/_company': {
      id: '/_authenticated/_company'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthenticatedCompanyRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/_agency': {
      id: '/_authenticated/_agency'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthenticatedAgencyRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/_admin': {
      id: '/_authenticated/_admin'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthenticatedAdminRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/influencer/$influencerId/': {
      id: '/influencer/$influencerId/'
      path: '/influencer/$influencerId'
      fullPath: '/influencer/$influencerId'
      preLoaderRoute: typeof InfluencerInfluencerIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/campaign/$campaignId/': {
      id: '/campaign/$campaignId/'
      path: '/campaign/$campaignId'
      fullPath: '/campaign/$campaignId'
      preLoaderRoute: typeof CampaignCampaignIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_unauthenticated/register/': {
      id: '/_unauthenticated/register/'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof UnauthenticatedRegisterIndexRouteImport
      parentRoute: typeof UnauthenticatedRoute
    }
    '/embed/join/$slug': {
      id: '/embed/join/$slug'
      path: '/embed/join/$slug'
      fullPath: '/embed/join/$slug'
      preLoaderRoute: typeof EmbedJoinSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_unauthenticated/register/agency': {
      id: '/_unauthenticated/register/agency'
      path: '/register/agency'
      fullPath: '/register/agency'
      preLoaderRoute: typeof UnauthenticatedRegisterAgencyRouteImport
      parentRoute: typeof UnauthenticatedRoute
    }
    '/_authenticated/campaign-reporting/$campaignId': {
      id: '/_authenticated/campaign-reporting/$campaignId'
      path: '/campaign-reporting/$campaignId'
      fullPath: '/campaign-reporting/$campaignId'
      preLoaderRoute: typeof AuthenticatedCampaignReportingCampaignIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/campaign-management/$campaignId': {
      id: '/_authenticated/campaign-management/$campaignId'
      path: '/campaign-management/$campaignId'
      fullPath: '/campaign-management/$campaignId'
      preLoaderRoute: typeof AuthenticatedCampaignManagementCampaignIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/campaign-management-ongoing/$campaignId': {
      id: '/_authenticated/campaign-management-ongoing/$campaignId'
      path: '/campaign-management-ongoing/$campaignId'
      fullPath: '/campaign-management-ongoing/$campaignId'
      preLoaderRoute: typeof AuthenticatedCampaignManagementOngoingCampaignIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/group/$groupId/': {
      id: '/_authenticated/group/$groupId/'
      path: '/group/$groupId'
      fullPath: '/group/$groupId'
      preLoaderRoute: typeof AuthenticatedGroupGroupIdIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/_admin/admins/': {
      id: '/_authenticated/_admin/admins/'
      path: '/admins'
      fullPath: '/admins'
      preLoaderRoute: typeof AuthenticatedAdminAdminsIndexRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/influencer/$influencerId/edit': {
      id: '/_authenticated/influencer/$influencerId/edit'
      path: '/influencer/$influencerId/edit'
      fullPath: '/influencer/$influencerId/edit'
      preLoaderRoute: typeof AuthenticatedInfluencerInfluencerIdEditRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/company/$companyId/welcome': {
      id: '/_authenticated/company/$companyId/welcome'
      path: '/company/$companyId/welcome'
      fullPath: '/company/$companyId/welcome'
      preLoaderRoute: typeof AuthenticatedCompanyCompanyIdWelcomeRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/company/$companyId/edit': {
      id: '/_authenticated/company/$companyId/edit'
      path: '/company/$companyId/edit'
      fullPath: '/company/$companyId/edit'
      preLoaderRoute: typeof AuthenticatedCompanyCompanyIdEditRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/campaign/$campaignId/edit': {
      id: '/_authenticated/campaign/$campaignId/edit'
      path: '/campaign/$campaignId/edit'
      fullPath: '/campaign/$campaignId/edit'
      preLoaderRoute: typeof AuthenticatedCampaignCampaignIdEditRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/_admin/admins/tiktok-media-manager': {
      id: '/_authenticated/_admin/admins/tiktok-media-manager'
      path: '/admins/tiktok-media-manager'
      fullPath: '/admins/tiktok-media-manager'
      preLoaderRoute: typeof AuthenticatedAdminAdminsTiktokMediaManagerRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/_admin/admins/instagram-media-manager': {
      id: '/_authenticated/_admin/admins/instagram-media-manager'
      path: '/admins/instagram-media-manager'
      fullPath: '/admins/instagram-media-manager'
      preLoaderRoute: typeof AuthenticatedAdminAdminsInstagramMediaManagerRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/_admin/admins/impersonate': {
      id: '/_authenticated/_admin/admins/impersonate'
      path: '/admins/impersonate'
      fullPath: '/admins/impersonate'
      preLoaderRoute: typeof AuthenticatedAdminAdminsImpersonateRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/_admin/admins/hub': {
      id: '/_authenticated/_admin/admins/hub'
      path: '/admins/hub'
      fullPath: '/admins/hub'
      preLoaderRoute: typeof AuthenticatedAdminAdminsHubRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/_admin/admins/customers': {
      id: '/_authenticated/_admin/admins/customers'
      path: '/admins/customers'
      fullPath: '/admins/customers'
      preLoaderRoute: typeof AuthenticatedAdminAdminsCustomersRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/_admin/admins/customer-success': {
      id: '/_authenticated/_admin/admins/customer-success'
      path: '/admins/customer-success'
      fullPath: '/admins/customer-success'
      preLoaderRoute: typeof AuthenticatedAdminAdminsCustomerSuccessRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/_admin/admins/bulk-sms': {
      id: '/_authenticated/_admin/admins/bulk-sms'
      path: '/admins/bulk-sms'
      fullPath: '/admins/bulk-sms'
      preLoaderRoute: typeof AuthenticatedAdminAdminsBulkSmsRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/_admin/admins/bulk-notification': {
      id: '/_authenticated/_admin/admins/bulk-notification'
      path: '/admins/bulk-notification'
      fullPath: '/admins/bulk-notification'
      preLoaderRoute: typeof AuthenticatedAdminAdminsBulkNotificationRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/_admin/_legacy/tiktok-media-manager': {
      id: '/_authenticated/_admin/_legacy/tiktok-media-manager'
      path: '/tiktok-media-manager'
      fullPath: '/tiktok-media-manager'
      preLoaderRoute: typeof AuthenticatedAdminLegacyTiktokMediaManagerRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/_admin/_legacy/instagram-media-manager': {
      id: '/_authenticated/_admin/_legacy/instagram-media-manager'
      path: '/instagram-media-manager'
      fullPath: '/instagram-media-manager'
      preLoaderRoute: typeof AuthenticatedAdminLegacyInstagramMediaManagerRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/_admin/_legacy/customers': {
      id: '/_authenticated/_admin/_legacy/customers'
      path: '/customers'
      fullPath: '/customers'
      preLoaderRoute: typeof AuthenticatedAdminLegacyCustomersRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/_admin/_legacy/bulk-sms': {
      id: '/_authenticated/_admin/_legacy/bulk-sms'
      path: '/bulk-sms'
      fullPath: '/bulk-sms'
      preLoaderRoute: typeof AuthenticatedAdminLegacyBulkSmsRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/_admin/_legacy/bulk-notification': {
      id: '/_authenticated/_admin/_legacy/bulk-notification'
      path: '/bulk-notification'
      fullPath: '/bulk-notification'
      preLoaderRoute: typeof AuthenticatedAdminLegacyBulkNotificationRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/_company/company/$companyId/': {
      id: '/_authenticated/_company/company/$companyId/'
      path: '/company/$companyId'
      fullPath: '/company/$companyId'
      preLoaderRoute: typeof AuthenticatedCompanyCompanyCompanyIdIndexRouteImport
      parentRoute: typeof AuthenticatedCompanyRoute
    }
    '/_authenticated/_agency/agency/$agencyId/': {
      id: '/_authenticated/_agency/agency/$agencyId/'
      path: '/agency/$agencyId'
      fullPath: '/agency/$agencyId'
      preLoaderRoute: typeof AuthenticatedAgencyAgencyAgencyIdIndexRouteImport
      parentRoute: typeof AuthenticatedAgencyRoute
    }
    '/_authenticated/_admin/admins/boost-estimate/': {
      id: '/_authenticated/_admin/admins/boost-estimate/'
      path: '/admins/boost-estimate'
      fullPath: '/admins/boost-estimate'
      preLoaderRoute: typeof AuthenticatedAdminAdminsBoostEstimateIndexRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/_company/company/$companyId/sent-ambassador-invites': {
      id: '/_authenticated/_company/company/$companyId/sent-ambassador-invites'
      path: '/company/$companyId/sent-ambassador-invites'
      fullPath: '/company/$companyId/sent-ambassador-invites'
      preLoaderRoute: typeof AuthenticatedCompanyCompanyCompanyIdSentAmbassadorInvitesRouteImport
      parentRoute: typeof AuthenticatedCompanyRoute
    }
    '/_authenticated/_company/company/$companyId/search-visibility': {
      id: '/_authenticated/_company/company/$companyId/search-visibility'
      path: '/company/$companyId/search-visibility'
      fullPath: '/company/$companyId/search-visibility'
      preLoaderRoute: typeof AuthenticatedCompanyCompanyCompanyIdSearchVisibilityRouteImport
      parentRoute: typeof AuthenticatedCompanyRoute
    }
    '/_authenticated/_company/company/$companyId/pending-ambassadors': {
      id: '/_authenticated/_company/company/$companyId/pending-ambassadors'
      path: '/company/$companyId/pending-ambassadors'
      fullPath: '/company/$companyId/pending-ambassadors'
      preLoaderRoute: typeof AuthenticatedCompanyCompanyCompanyIdPendingAmbassadorsRouteImport
      parentRoute: typeof AuthenticatedCompanyRoute
    }
    '/_authenticated/_company/company/$companyId/media-library': {
      id: '/_authenticated/_company/company/$companyId/media-library'
      path: '/company/$companyId/media-library'
      fullPath: '/company/$companyId/media-library'
      preLoaderRoute: typeof AuthenticatedCompanyCompanyCompanyIdMediaLibraryRouteImport
      parentRoute: typeof AuthenticatedCompanyRoute
    }
    '/_authenticated/_company/company/$companyId/invoices': {
      id: '/_authenticated/_company/company/$companyId/invoices'
      path: '/company/$companyId/invoices'
      fullPath: '/company/$companyId/invoices'
      preLoaderRoute: typeof AuthenticatedCompanyCompanyCompanyIdInvoicesRouteImport
      parentRoute: typeof AuthenticatedCompanyRoute
    }
    '/_authenticated/_company/company/$companyId/groups': {
      id: '/_authenticated/_company/company/$companyId/groups'
      path: '/company/$companyId/groups'
      fullPath: '/company/$companyId/groups'
      preLoaderRoute: typeof AuthenticatedCompanyCompanyCompanyIdGroupsRouteImport
      parentRoute: typeof AuthenticatedCompanyRoute
    }
    '/_authenticated/_company/company/$companyId/dashboard': {
      id: '/_authenticated/_company/company/$companyId/dashboard'
      path: '/company/$companyId/dashboard'
      fullPath: '/company/$companyId/dashboard'
      preLoaderRoute: typeof AuthenticatedCompanyCompanyCompanyIdDashboardRouteImport
      parentRoute: typeof AuthenticatedCompanyRoute
    }
    '/_authenticated/_company/company/$companyId/blocked-influencers': {
      id: '/_authenticated/_company/company/$companyId/blocked-influencers'
      path: '/company/$companyId/blocked-influencers'
      fullPath: '/company/$companyId/blocked-influencers'
      preLoaderRoute: typeof AuthenticatedCompanyCompanyCompanyIdBlockedInfluencersRouteImport
      parentRoute: typeof AuthenticatedCompanyRoute
    }
    '/_authenticated/_company/_legacy/my_campaigns/$companyId': {
      id: '/_authenticated/_company/_legacy/my_campaigns/$companyId'
      path: '/my_campaigns/$companyId'
      fullPath: '/my_campaigns/$companyId'
      preLoaderRoute: typeof AuthenticatedCompanyLegacyMy_campaignsCompanyIdRouteImport
      parentRoute: typeof AuthenticatedCompanyRoute
    }
    '/_authenticated/_company/_legacy/company-edit/$companyId': {
      id: '/_authenticated/_company/_legacy/company-edit/$companyId'
      path: '/company-edit/$companyId'
      fullPath: '/company-edit/$companyId'
      preLoaderRoute: typeof AuthenticatedCompanyLegacyCompanyEditCompanyIdRouteImport
      parentRoute: typeof AuthenticatedCompanyRoute
    }
    '/_authenticated/_agency/agency/$agencyId/media-library': {
      id: '/_authenticated/_agency/agency/$agencyId/media-library'
      path: '/agency/$agencyId/media-library'
      fullPath: '/agency/$agencyId/media-library'
      preLoaderRoute: typeof AuthenticatedAgencyAgencyAgencyIdMediaLibraryRouteImport
      parentRoute: typeof AuthenticatedAgencyRoute
    }
    '/_authenticated/_agency/agency/$agencyId/groups': {
      id: '/_authenticated/_agency/agency/$agencyId/groups'
      path: '/agency/$agencyId/groups'
      fullPath: '/agency/$agencyId/groups'
      preLoaderRoute: typeof AuthenticatedAgencyAgencyAgencyIdGroupsRouteImport
      parentRoute: typeof AuthenticatedAgencyRoute
    }
    '/_authenticated/_agency/agency/$agencyId/edit': {
      id: '/_authenticated/_agency/agency/$agencyId/edit'
      path: '/agency/$agencyId/edit'
      fullPath: '/agency/$agencyId/edit'
      preLoaderRoute: typeof AuthenticatedAgencyAgencyAgencyIdEditRouteImport
      parentRoute: typeof AuthenticatedAgencyRoute
    }
    '/_authenticated/_agency/agency/$agencyId/dashboard': {
      id: '/_authenticated/_agency/agency/$agencyId/dashboard'
      path: '/agency/$agencyId/dashboard'
      fullPath: '/agency/$agencyId/dashboard'
      preLoaderRoute: typeof AuthenticatedAgencyAgencyAgencyIdDashboardRouteImport
      parentRoute: typeof AuthenticatedAgencyRoute
    }
    '/_authenticated/_agency/agency/$agencyId/customers': {
      id: '/_authenticated/_agency/agency/$agencyId/customers'
      path: '/agency/$agencyId/customers'
      fullPath: '/agency/$agencyId/customers'
      preLoaderRoute: typeof AuthenticatedAgencyAgencyAgencyIdCustomersRouteImport
      parentRoute: typeof AuthenticatedAgencyRoute
    }
    '/_authenticated/_admin/admins/boost-estimate/$campaignId': {
      id: '/_authenticated/_admin/admins/boost-estimate/$campaignId'
      path: '/admins/boost-estimate/$campaignId'
      fullPath: '/admins/boost-estimate/$campaignId'
      preLoaderRoute: typeof AuthenticatedAdminAdminsBoostEstimateCampaignIdRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/_admin/admins/agency/create': {
      id: '/_authenticated/_admin/admins/agency/create'
      path: '/admins/agency/create'
      fullPath: '/admins/agency/create'
      preLoaderRoute: typeof AuthenticatedAdminAdminsAgencyCreateRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/_admin/admins/accounts/combine': {
      id: '/_authenticated/_admin/admins/accounts/combine'
      path: '/admins/accounts/combine'
      fullPath: '/admins/accounts/combine'
      preLoaderRoute: typeof AuthenticatedAdminAdminsAccountsCombineRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/_admin/_legacy/agency/create': {
      id: '/_authenticated/_admin/_legacy/agency/create'
      path: '/agency/create'
      fullPath: '/agency/create'
      preLoaderRoute: typeof AuthenticatedAdminLegacyAgencyCreateRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/_admin/_legacy/accounts/combine': {
      id: '/_authenticated/_admin/_legacy/accounts/combine'
      path: '/accounts/combine'
      fullPath: '/accounts/combine'
      preLoaderRoute: typeof AuthenticatedAdminLegacyAccountsCombineRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/_company/company/$companyId/campaigns/$status': {
      id: '/_authenticated/_company/company/$companyId/campaigns/$status'
      path: '/company/$companyId/campaigns/$status'
      fullPath: '/company/$companyId/campaigns/$status'
      preLoaderRoute: typeof AuthenticatedCompanyCompanyCompanyIdCampaignsStatusRouteImport
      parentRoute: typeof AuthenticatedCompanyRoute
    }
    '/_authenticated/_agency/agency/$agencyId/campaigns/$status': {
      id: '/_authenticated/_agency/agency/$agencyId/campaigns/$status'
      path: '/agency/$agencyId/campaigns/$status'
      fullPath: '/agency/$agencyId/campaigns/$status'
      preLoaderRoute: typeof AuthenticatedAgencyAgencyAgencyIdCampaignsStatusRouteImport
      parentRoute: typeof AuthenticatedAgencyRoute
    }
    '/_authenticated/_agency/agency/$agencyId/subbrand/$companyId/': {
      id: '/_authenticated/_agency/agency/$agencyId/subbrand/$companyId/'
      path: '/agency/$agencyId/subbrand/$companyId'
      fullPath: '/agency/$agencyId/subbrand/$companyId'
      preLoaderRoute: typeof AuthenticatedAgencyAgencyAgencyIdSubbrandCompanyIdIndexRouteImport
      parentRoute: typeof AuthenticatedAgencyRoute
    }
    '/_authenticated/_company/company/$companyId/chat/{-$campaignId}/{-$influencerUserId}': {
      id: '/_authenticated/_company/company/$companyId/chat/{-$campaignId}/{-$influencerUserId}'
      path: '/company/$companyId/chat/{-$campaignId}/{-$influencerUserId}'
      fullPath: '/company/$companyId/chat/{-$campaignId}/{-$influencerUserId}'
      preLoaderRoute: typeof AuthenticatedCompanyCompanyCompanyIdChatChar123CampaignIdChar125Char123InfluencerUserIdChar125RouteImport
      parentRoute: typeof AuthenticatedCompanyRoute
    }
    '/_authenticated/_agency/agency/$agencyId/subbrand/$companyId/sent-ambassador-invites': {
      id: '/_authenticated/_agency/agency/$agencyId/subbrand/$companyId/sent-ambassador-invites'
      path: '/agency/$agencyId/subbrand/$companyId/sent-ambassador-invites'
      fullPath: '/agency/$agencyId/subbrand/$companyId/sent-ambassador-invites'
      preLoaderRoute: typeof AuthenticatedAgencyAgencyAgencyIdSubbrandCompanyIdSentAmbassadorInvitesRouteImport
      parentRoute: typeof AuthenticatedAgencyRoute
    }
    '/_authenticated/_agency/agency/$agencyId/subbrand/$companyId/search-visibility': {
      id: '/_authenticated/_agency/agency/$agencyId/subbrand/$companyId/search-visibility'
      path: '/agency/$agencyId/subbrand/$companyId/search-visibility'
      fullPath: '/agency/$agencyId/subbrand/$companyId/search-visibility'
      preLoaderRoute: typeof AuthenticatedAgencyAgencyAgencyIdSubbrandCompanyIdSearchVisibilityRouteImport
      parentRoute: typeof AuthenticatedAgencyRoute
    }
    '/_authenticated/_agency/agency/$agencyId/subbrand/$companyId/pending-ambassadors': {
      id: '/_authenticated/_agency/agency/$agencyId/subbrand/$companyId/pending-ambassadors'
      path: '/agency/$agencyId/subbrand/$companyId/pending-ambassadors'
      fullPath: '/agency/$agencyId/subbrand/$companyId/pending-ambassadors'
      preLoaderRoute: typeof AuthenticatedAgencyAgencyAgencyIdSubbrandCompanyIdPendingAmbassadorsRouteImport
      parentRoute: typeof AuthenticatedAgencyRoute
    }
    '/_authenticated/_agency/agency/$agencyId/subbrand/$companyId/media-library': {
      id: '/_authenticated/_agency/agency/$agencyId/subbrand/$companyId/media-library'
      path: '/agency/$agencyId/subbrand/$companyId/media-library'
      fullPath: '/agency/$agencyId/subbrand/$companyId/media-library'
      preLoaderRoute: typeof AuthenticatedAgencyAgencyAgencyIdSubbrandCompanyIdMediaLibraryRouteImport
      parentRoute: typeof AuthenticatedAgencyRoute
    }
    '/_authenticated/_agency/agency/$agencyId/subbrand/$companyId/invoices': {
      id: '/_authenticated/_agency/agency/$agencyId/subbrand/$companyId/invoices'
      path: '/agency/$agencyId/subbrand/$companyId/invoices'
      fullPath: '/agency/$agencyId/subbrand/$companyId/invoices'
      preLoaderRoute: typeof AuthenticatedAgencyAgencyAgencyIdSubbrandCompanyIdInvoicesRouteImport
      parentRoute: typeof AuthenticatedAgencyRoute
    }
    '/_authenticated/_agency/agency/$agencyId/subbrand/$companyId/groups': {
      id: '/_authenticated/_agency/agency/$agencyId/subbrand/$companyId/groups'
      path: '/agency/$agencyId/subbrand/$companyId/groups'
      fullPath: '/agency/$agencyId/subbrand/$companyId/groups'
      preLoaderRoute: typeof AuthenticatedAgencyAgencyAgencyIdSubbrandCompanyIdGroupsRouteImport
      parentRoute: typeof AuthenticatedAgencyRoute
    }
    '/_authenticated/_agency/agency/$agencyId/subbrand/$companyId/edit': {
      id: '/_authenticated/_agency/agency/$agencyId/subbrand/$companyId/edit'
      path: '/agency/$agencyId/subbrand/$companyId/edit'
      fullPath: '/agency/$agencyId/subbrand/$companyId/edit'
      preLoaderRoute: typeof AuthenticatedAgencyAgencyAgencyIdSubbrandCompanyIdEditRouteImport
      parentRoute: typeof AuthenticatedAgencyRoute
    }
    '/_authenticated/_agency/agency/$agencyId/subbrand/$companyId/dashboard': {
      id: '/_authenticated/_agency/agency/$agencyId/subbrand/$companyId/dashboard'
      path: '/agency/$agencyId/subbrand/$companyId/dashboard'
      fullPath: '/agency/$agencyId/subbrand/$companyId/dashboard'
      preLoaderRoute: typeof AuthenticatedAgencyAgencyAgencyIdSubbrandCompanyIdDashboardRouteImport
      parentRoute: typeof AuthenticatedAgencyRoute
    }
    '/_authenticated/_agency/agency/$agencyId/subbrand/$companyId/blocked-influencers': {
      id: '/_authenticated/_agency/agency/$agencyId/subbrand/$companyId/blocked-influencers'
      path: '/agency/$agencyId/subbrand/$companyId/blocked-influencers'
      fullPath: '/agency/$agencyId/subbrand/$companyId/blocked-influencers'
      preLoaderRoute: typeof AuthenticatedAgencyAgencyAgencyIdSubbrandCompanyIdBlockedInfluencersRouteImport
      parentRoute: typeof AuthenticatedAgencyRoute
    }
    '/_authenticated/_agency/agency/$agencyId/subbrand/$companyId/campaigns/$status': {
      id: '/_authenticated/_agency/agency/$agencyId/subbrand/$companyId/campaigns/$status'
      path: '/agency/$agencyId/subbrand/$companyId/campaigns/$status'
      fullPath: '/agency/$agencyId/subbrand/$companyId/campaigns/$status'
      preLoaderRoute: typeof AuthenticatedAgencyAgencyAgencyIdSubbrandCompanyIdCampaignsStatusRouteImport
      parentRoute: typeof AuthenticatedAgencyRoute
    }
    '/_authenticated/_agency/agency/$agencyId/chat/$companyId/{-$campaignId}/{-$influencerUserId}': {
      id: '/_authenticated/_agency/agency/$agencyId/chat/$companyId/{-$campaignId}/{-$influencerUserId}'
      path: '/agency/$agencyId/chat/$companyId/{-$campaignId}/{-$influencerUserId}'
      fullPath: '/agency/$agencyId/chat/$companyId/{-$campaignId}/{-$influencerUserId}'
      preLoaderRoute: typeof AuthenticatedAgencyAgencyAgencyIdChatCompanyIdChar123CampaignIdChar125Char123InfluencerUserIdChar125RouteImport
      parentRoute: typeof AuthenticatedAgencyRoute
    }
  }
}

interface AuthenticatedAdminRouteChildren {
  AuthenticatedAdminLegacyBulkNotificationRoute: typeof AuthenticatedAdminLegacyBulkNotificationRoute
  AuthenticatedAdminLegacyBulkSmsRoute: typeof AuthenticatedAdminLegacyBulkSmsRoute
  AuthenticatedAdminLegacyCustomersRoute: typeof AuthenticatedAdminLegacyCustomersRoute
  AuthenticatedAdminLegacyInstagramMediaManagerRoute: typeof AuthenticatedAdminLegacyInstagramMediaManagerRoute
  AuthenticatedAdminLegacyTiktokMediaManagerRoute: typeof AuthenticatedAdminLegacyTiktokMediaManagerRoute
  AuthenticatedAdminAdminsBulkNotificationRoute: typeof AuthenticatedAdminAdminsBulkNotificationRoute
  AuthenticatedAdminAdminsBulkSmsRoute: typeof AuthenticatedAdminAdminsBulkSmsRoute
  AuthenticatedAdminAdminsCustomerSuccessRoute: typeof AuthenticatedAdminAdminsCustomerSuccessRoute
  AuthenticatedAdminAdminsCustomersRoute: typeof AuthenticatedAdminAdminsCustomersRoute
  AuthenticatedAdminAdminsHubRoute: typeof AuthenticatedAdminAdminsHubRoute
  AuthenticatedAdminAdminsImpersonateRoute: typeof AuthenticatedAdminAdminsImpersonateRoute
  AuthenticatedAdminAdminsInstagramMediaManagerRoute: typeof AuthenticatedAdminAdminsInstagramMediaManagerRoute
  AuthenticatedAdminAdminsTiktokMediaManagerRoute: typeof AuthenticatedAdminAdminsTiktokMediaManagerRoute
  AuthenticatedAdminAdminsIndexRoute: typeof AuthenticatedAdminAdminsIndexRoute
  AuthenticatedAdminLegacyAccountsCombineRoute: typeof AuthenticatedAdminLegacyAccountsCombineRoute
  AuthenticatedAdminLegacyAgencyCreateRoute: typeof AuthenticatedAdminLegacyAgencyCreateRoute
  AuthenticatedAdminAdminsAccountsCombineRoute: typeof AuthenticatedAdminAdminsAccountsCombineRoute
  AuthenticatedAdminAdminsAgencyCreateRoute: typeof AuthenticatedAdminAdminsAgencyCreateRoute
  AuthenticatedAdminAdminsBoostEstimateCampaignIdRoute: typeof AuthenticatedAdminAdminsBoostEstimateCampaignIdRoute
  AuthenticatedAdminAdminsBoostEstimateIndexRoute: typeof AuthenticatedAdminAdminsBoostEstimateIndexRoute
}

const AuthenticatedAdminRouteChildren: AuthenticatedAdminRouteChildren = {
  AuthenticatedAdminLegacyBulkNotificationRoute:
    AuthenticatedAdminLegacyBulkNotificationRoute,
  AuthenticatedAdminLegacyBulkSmsRoute: AuthenticatedAdminLegacyBulkSmsRoute,
  AuthenticatedAdminLegacyCustomersRoute:
    AuthenticatedAdminLegacyCustomersRoute,
  AuthenticatedAdminLegacyInstagramMediaManagerRoute:
    AuthenticatedAdminLegacyInstagramMediaManagerRoute,
  AuthenticatedAdminLegacyTiktokMediaManagerRoute:
    AuthenticatedAdminLegacyTiktokMediaManagerRoute,
  AuthenticatedAdminAdminsBulkNotificationRoute:
    AuthenticatedAdminAdminsBulkNotificationRoute,
  AuthenticatedAdminAdminsBulkSmsRoute: AuthenticatedAdminAdminsBulkSmsRoute,
  AuthenticatedAdminAdminsCustomerSuccessRoute:
    AuthenticatedAdminAdminsCustomerSuccessRoute,
  AuthenticatedAdminAdminsCustomersRoute:
    AuthenticatedAdminAdminsCustomersRoute,
  AuthenticatedAdminAdminsHubRoute: AuthenticatedAdminAdminsHubRoute,
  AuthenticatedAdminAdminsImpersonateRoute:
    AuthenticatedAdminAdminsImpersonateRoute,
  AuthenticatedAdminAdminsInstagramMediaManagerRoute:
    AuthenticatedAdminAdminsInstagramMediaManagerRoute,
  AuthenticatedAdminAdminsTiktokMediaManagerRoute:
    AuthenticatedAdminAdminsTiktokMediaManagerRoute,
  AuthenticatedAdminAdminsIndexRoute: AuthenticatedAdminAdminsIndexRoute,
  AuthenticatedAdminLegacyAccountsCombineRoute:
    AuthenticatedAdminLegacyAccountsCombineRoute,
  AuthenticatedAdminLegacyAgencyCreateRoute:
    AuthenticatedAdminLegacyAgencyCreateRoute,
  AuthenticatedAdminAdminsAccountsCombineRoute:
    AuthenticatedAdminAdminsAccountsCombineRoute,
  AuthenticatedAdminAdminsAgencyCreateRoute:
    AuthenticatedAdminAdminsAgencyCreateRoute,
  AuthenticatedAdminAdminsBoostEstimateCampaignIdRoute:
    AuthenticatedAdminAdminsBoostEstimateCampaignIdRoute,
  AuthenticatedAdminAdminsBoostEstimateIndexRoute:
    AuthenticatedAdminAdminsBoostEstimateIndexRoute,
}

const AuthenticatedAdminRouteWithChildren =
  AuthenticatedAdminRoute._addFileChildren(AuthenticatedAdminRouteChildren)

interface AuthenticatedAgencyRouteChildren {
  AuthenticatedAgencyAgencyAgencyIdCustomersRoute: typeof AuthenticatedAgencyAgencyAgencyIdCustomersRoute
  AuthenticatedAgencyAgencyAgencyIdDashboardRoute: typeof AuthenticatedAgencyAgencyAgencyIdDashboardRoute
  AuthenticatedAgencyAgencyAgencyIdEditRoute: typeof AuthenticatedAgencyAgencyAgencyIdEditRoute
  AuthenticatedAgencyAgencyAgencyIdGroupsRoute: typeof AuthenticatedAgencyAgencyAgencyIdGroupsRoute
  AuthenticatedAgencyAgencyAgencyIdMediaLibraryRoute: typeof AuthenticatedAgencyAgencyAgencyIdMediaLibraryRoute
  AuthenticatedAgencyAgencyAgencyIdIndexRoute: typeof AuthenticatedAgencyAgencyAgencyIdIndexRoute
  AuthenticatedAgencyAgencyAgencyIdCampaignsStatusRoute: typeof AuthenticatedAgencyAgencyAgencyIdCampaignsStatusRoute
  AuthenticatedAgencyAgencyAgencyIdSubbrandCompanyIdBlockedInfluencersRoute: typeof AuthenticatedAgencyAgencyAgencyIdSubbrandCompanyIdBlockedInfluencersRoute
  AuthenticatedAgencyAgencyAgencyIdSubbrandCompanyIdDashboardRoute: typeof AuthenticatedAgencyAgencyAgencyIdSubbrandCompanyIdDashboardRoute
  AuthenticatedAgencyAgencyAgencyIdSubbrandCompanyIdEditRoute: typeof AuthenticatedAgencyAgencyAgencyIdSubbrandCompanyIdEditRoute
  AuthenticatedAgencyAgencyAgencyIdSubbrandCompanyIdGroupsRoute: typeof AuthenticatedAgencyAgencyAgencyIdSubbrandCompanyIdGroupsRoute
  AuthenticatedAgencyAgencyAgencyIdSubbrandCompanyIdInvoicesRoute: typeof AuthenticatedAgencyAgencyAgencyIdSubbrandCompanyIdInvoicesRoute
  AuthenticatedAgencyAgencyAgencyIdSubbrandCompanyIdMediaLibraryRoute: typeof AuthenticatedAgencyAgencyAgencyIdSubbrandCompanyIdMediaLibraryRoute
  AuthenticatedAgencyAgencyAgencyIdSubbrandCompanyIdPendingAmbassadorsRoute: typeof AuthenticatedAgencyAgencyAgencyIdSubbrandCompanyIdPendingAmbassadorsRoute
  AuthenticatedAgencyAgencyAgencyIdSubbrandCompanyIdSearchVisibilityRoute: typeof AuthenticatedAgencyAgencyAgencyIdSubbrandCompanyIdSearchVisibilityRoute
  AuthenticatedAgencyAgencyAgencyIdSubbrandCompanyIdSentAmbassadorInvitesRoute: typeof AuthenticatedAgencyAgencyAgencyIdSubbrandCompanyIdSentAmbassadorInvitesRoute
  AuthenticatedAgencyAgencyAgencyIdSubbrandCompanyIdIndexRoute: typeof AuthenticatedAgencyAgencyAgencyIdSubbrandCompanyIdIndexRoute
  AuthenticatedAgencyAgencyAgencyIdChatCompanyIdChar123CampaignIdChar125Char123InfluencerUserIdChar125Route: typeof AuthenticatedAgencyAgencyAgencyIdChatCompanyIdChar123CampaignIdChar125Char123InfluencerUserIdChar125Route
  AuthenticatedAgencyAgencyAgencyIdSubbrandCompanyIdCampaignsStatusRoute: typeof AuthenticatedAgencyAgencyAgencyIdSubbrandCompanyIdCampaignsStatusRoute
}

const AuthenticatedAgencyRouteChildren: AuthenticatedAgencyRouteChildren = {
  AuthenticatedAgencyAgencyAgencyIdCustomersRoute:
    AuthenticatedAgencyAgencyAgencyIdCustomersRoute,
  AuthenticatedAgencyAgencyAgencyIdDashboardRoute:
    AuthenticatedAgencyAgencyAgencyIdDashboardRoute,
  AuthenticatedAgencyAgencyAgencyIdEditRoute:
    AuthenticatedAgencyAgencyAgencyIdEditRoute,
  AuthenticatedAgencyAgencyAgencyIdGroupsRoute:
    AuthenticatedAgencyAgencyAgencyIdGroupsRoute,
  AuthenticatedAgencyAgencyAgencyIdMediaLibraryRoute:
    AuthenticatedAgencyAgencyAgencyIdMediaLibraryRoute,
  AuthenticatedAgencyAgencyAgencyIdIndexRoute:
    AuthenticatedAgencyAgencyAgencyIdIndexRoute,
  AuthenticatedAgencyAgencyAgencyIdCampaignsStatusRoute:
    AuthenticatedAgencyAgencyAgencyIdCampaignsStatusRoute,
  AuthenticatedAgencyAgencyAgencyIdSubbrandCompanyIdBlockedInfluencersRoute:
    AuthenticatedAgencyAgencyAgencyIdSubbrandCompanyIdBlockedInfluencersRoute,
  AuthenticatedAgencyAgencyAgencyIdSubbrandCompanyIdDashboardRoute:
    AuthenticatedAgencyAgencyAgencyIdSubbrandCompanyIdDashboardRoute,
  AuthenticatedAgencyAgencyAgencyIdSubbrandCompanyIdEditRoute:
    AuthenticatedAgencyAgencyAgencyIdSubbrandCompanyIdEditRoute,
  AuthenticatedAgencyAgencyAgencyIdSubbrandCompanyIdGroupsRoute:
    AuthenticatedAgencyAgencyAgencyIdSubbrandCompanyIdGroupsRoute,
  AuthenticatedAgencyAgencyAgencyIdSubbrandCompanyIdInvoicesRoute:
    AuthenticatedAgencyAgencyAgencyIdSubbrandCompanyIdInvoicesRoute,
  AuthenticatedAgencyAgencyAgencyIdSubbrandCompanyIdMediaLibraryRoute:
    AuthenticatedAgencyAgencyAgencyIdSubbrandCompanyIdMediaLibraryRoute,
  AuthenticatedAgencyAgencyAgencyIdSubbrandCompanyIdPendingAmbassadorsRoute:
    AuthenticatedAgencyAgencyAgencyIdSubbrandCompanyIdPendingAmbassadorsRoute,
  AuthenticatedAgencyAgencyAgencyIdSubbrandCompanyIdSearchVisibilityRoute:
    AuthenticatedAgencyAgencyAgencyIdSubbrandCompanyIdSearchVisibilityRoute,
  AuthenticatedAgencyAgencyAgencyIdSubbrandCompanyIdSentAmbassadorInvitesRoute:
    AuthenticatedAgencyAgencyAgencyIdSubbrandCompanyIdSentAmbassadorInvitesRoute,
  AuthenticatedAgencyAgencyAgencyIdSubbrandCompanyIdIndexRoute:
    AuthenticatedAgencyAgencyAgencyIdSubbrandCompanyIdIndexRoute,
  AuthenticatedAgencyAgencyAgencyIdChatCompanyIdChar123CampaignIdChar125Char123InfluencerUserIdChar125Route:
    AuthenticatedAgencyAgencyAgencyIdChatCompanyIdChar123CampaignIdChar125Char123InfluencerUserIdChar125Route,
  AuthenticatedAgencyAgencyAgencyIdSubbrandCompanyIdCampaignsStatusRoute:
    AuthenticatedAgencyAgencyAgencyIdSubbrandCompanyIdCampaignsStatusRoute,
}

const AuthenticatedAgencyRouteWithChildren =
  AuthenticatedAgencyRoute._addFileChildren(AuthenticatedAgencyRouteChildren)

interface AuthenticatedCompanyRouteChildren {
  AuthenticatedCompanyLegacyCompanyEditCompanyIdRoute: typeof AuthenticatedCompanyLegacyCompanyEditCompanyIdRoute
  AuthenticatedCompanyLegacyMy_campaignsCompanyIdRoute: typeof AuthenticatedCompanyLegacyMy_campaignsCompanyIdRoute
  AuthenticatedCompanyCompanyCompanyIdBlockedInfluencersRoute: typeof AuthenticatedCompanyCompanyCompanyIdBlockedInfluencersRoute
  AuthenticatedCompanyCompanyCompanyIdDashboardRoute: typeof AuthenticatedCompanyCompanyCompanyIdDashboardRoute
  AuthenticatedCompanyCompanyCompanyIdGroupsRoute: typeof AuthenticatedCompanyCompanyCompanyIdGroupsRoute
  AuthenticatedCompanyCompanyCompanyIdInvoicesRoute: typeof AuthenticatedCompanyCompanyCompanyIdInvoicesRoute
  AuthenticatedCompanyCompanyCompanyIdMediaLibraryRoute: typeof AuthenticatedCompanyCompanyCompanyIdMediaLibraryRoute
  AuthenticatedCompanyCompanyCompanyIdPendingAmbassadorsRoute: typeof AuthenticatedCompanyCompanyCompanyIdPendingAmbassadorsRoute
  AuthenticatedCompanyCompanyCompanyIdSearchVisibilityRoute: typeof AuthenticatedCompanyCompanyCompanyIdSearchVisibilityRoute
  AuthenticatedCompanyCompanyCompanyIdSentAmbassadorInvitesRoute: typeof AuthenticatedCompanyCompanyCompanyIdSentAmbassadorInvitesRoute
  AuthenticatedCompanyCompanyCompanyIdIndexRoute: typeof AuthenticatedCompanyCompanyCompanyIdIndexRoute
  AuthenticatedCompanyCompanyCompanyIdCampaignsStatusRoute: typeof AuthenticatedCompanyCompanyCompanyIdCampaignsStatusRoute
  AuthenticatedCompanyCompanyCompanyIdChatChar123CampaignIdChar125Char123InfluencerUserIdChar125Route: typeof AuthenticatedCompanyCompanyCompanyIdChatChar123CampaignIdChar125Char123InfluencerUserIdChar125Route
}

const AuthenticatedCompanyRouteChildren: AuthenticatedCompanyRouteChildren = {
  AuthenticatedCompanyLegacyCompanyEditCompanyIdRoute:
    AuthenticatedCompanyLegacyCompanyEditCompanyIdRoute,
  AuthenticatedCompanyLegacyMy_campaignsCompanyIdRoute:
    AuthenticatedCompanyLegacyMy_campaignsCompanyIdRoute,
  AuthenticatedCompanyCompanyCompanyIdBlockedInfluencersRoute:
    AuthenticatedCompanyCompanyCompanyIdBlockedInfluencersRoute,
  AuthenticatedCompanyCompanyCompanyIdDashboardRoute:
    AuthenticatedCompanyCompanyCompanyIdDashboardRoute,
  AuthenticatedCompanyCompanyCompanyIdGroupsRoute:
    AuthenticatedCompanyCompanyCompanyIdGroupsRoute,
  AuthenticatedCompanyCompanyCompanyIdInvoicesRoute:
    AuthenticatedCompanyCompanyCompanyIdInvoicesRoute,
  AuthenticatedCompanyCompanyCompanyIdMediaLibraryRoute:
    AuthenticatedCompanyCompanyCompanyIdMediaLibraryRoute,
  AuthenticatedCompanyCompanyCompanyIdPendingAmbassadorsRoute:
    AuthenticatedCompanyCompanyCompanyIdPendingAmbassadorsRoute,
  AuthenticatedCompanyCompanyCompanyIdSearchVisibilityRoute:
    AuthenticatedCompanyCompanyCompanyIdSearchVisibilityRoute,
  AuthenticatedCompanyCompanyCompanyIdSentAmbassadorInvitesRoute:
    AuthenticatedCompanyCompanyCompanyIdSentAmbassadorInvitesRoute,
  AuthenticatedCompanyCompanyCompanyIdIndexRoute:
    AuthenticatedCompanyCompanyCompanyIdIndexRoute,
  AuthenticatedCompanyCompanyCompanyIdCampaignsStatusRoute:
    AuthenticatedCompanyCompanyCompanyIdCampaignsStatusRoute,
  AuthenticatedCompanyCompanyCompanyIdChatChar123CampaignIdChar125Char123InfluencerUserIdChar125Route:
    AuthenticatedCompanyCompanyCompanyIdChatChar123CampaignIdChar125Char123InfluencerUserIdChar125Route,
}

const AuthenticatedCompanyRouteWithChildren =
  AuthenticatedCompanyRoute._addFileChildren(AuthenticatedCompanyRouteChildren)

interface AuthenticatedRouteChildren {
  AuthenticatedAdminRoute: typeof AuthenticatedAdminRouteWithChildren
  AuthenticatedAgencyRoute: typeof AuthenticatedAgencyRouteWithChildren
  AuthenticatedCompanyRoute: typeof AuthenticatedCompanyRouteWithChildren
  AuthenticatedCampaignsRoute: typeof AuthenticatedCampaignsRoute
  AuthenticatedChatRoute: typeof AuthenticatedChatRoute
  AuthenticatedGroupsRoute: typeof AuthenticatedGroupsRoute
  AuthenticatedImageUploadRoute: typeof AuthenticatedImageUploadRoute
  AuthenticatedLogoutRoute: typeof AuthenticatedLogoutRoute
  AuthenticatedMediaLibraryRoute: typeof AuthenticatedMediaLibraryRoute
  AuthenticatedPlansRoute: typeof AuthenticatedPlansRoute
  AuthenticatedProfileRoute: typeof AuthenticatedProfileRoute
  AuthenticatedSearchVisibilityRoute: typeof AuthenticatedSearchVisibilityRoute
  AuthenticatedCampaignManagementOngoingCampaignIdRoute: typeof AuthenticatedCampaignManagementOngoingCampaignIdRoute
  AuthenticatedCampaignManagementCampaignIdRoute: typeof AuthenticatedCampaignManagementCampaignIdRoute
  AuthenticatedCampaignReportingCampaignIdRoute: typeof AuthenticatedCampaignReportingCampaignIdRoute
  AuthenticatedCampaignCampaignIdEditRoute: typeof AuthenticatedCampaignCampaignIdEditRoute
  AuthenticatedCompanyCompanyIdEditRoute: typeof AuthenticatedCompanyCompanyIdEditRoute
  AuthenticatedCompanyCompanyIdWelcomeRoute: typeof AuthenticatedCompanyCompanyIdWelcomeRoute
  AuthenticatedInfluencerInfluencerIdEditRoute: typeof AuthenticatedInfluencerInfluencerIdEditRoute
  AuthenticatedGroupGroupIdIndexRoute: typeof AuthenticatedGroupGroupIdIndexRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedAdminRoute: AuthenticatedAdminRouteWithChildren,
  AuthenticatedAgencyRoute: AuthenticatedAgencyRouteWithChildren,
  AuthenticatedCompanyRoute: AuthenticatedCompanyRouteWithChildren,
  AuthenticatedCampaignsRoute: AuthenticatedCampaignsRoute,
  AuthenticatedChatRoute: AuthenticatedChatRoute,
  AuthenticatedGroupsRoute: AuthenticatedGroupsRoute,
  AuthenticatedImageUploadRoute: AuthenticatedImageUploadRoute,
  AuthenticatedLogoutRoute: AuthenticatedLogoutRoute,
  AuthenticatedMediaLibraryRoute: AuthenticatedMediaLibraryRoute,
  AuthenticatedPlansRoute: AuthenticatedPlansRoute,
  AuthenticatedProfileRoute: AuthenticatedProfileRoute,
  AuthenticatedSearchVisibilityRoute: AuthenticatedSearchVisibilityRoute,
  AuthenticatedCampaignManagementOngoingCampaignIdRoute:
    AuthenticatedCampaignManagementOngoingCampaignIdRoute,
  AuthenticatedCampaignManagementCampaignIdRoute:
    AuthenticatedCampaignManagementCampaignIdRoute,
  AuthenticatedCampaignReportingCampaignIdRoute:
    AuthenticatedCampaignReportingCampaignIdRoute,
  AuthenticatedCampaignCampaignIdEditRoute:
    AuthenticatedCampaignCampaignIdEditRoute,
  AuthenticatedCompanyCompanyIdEditRoute:
    AuthenticatedCompanyCompanyIdEditRoute,
  AuthenticatedCompanyCompanyIdWelcomeRoute:
    AuthenticatedCompanyCompanyIdWelcomeRoute,
  AuthenticatedInfluencerInfluencerIdEditRoute:
    AuthenticatedInfluencerInfluencerIdEditRoute,
  AuthenticatedGroupGroupIdIndexRoute: AuthenticatedGroupGroupIdIndexRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

interface UnauthenticatedRouteChildren {
  UnauthenticatedLoginRoute: typeof UnauthenticatedLoginRoute
  UnauthenticatedOnboardingRoute: typeof UnauthenticatedOnboardingRoute
  UnauthenticatedRequestResetRoute: typeof UnauthenticatedRequestResetRoute
  UnauthenticatedResetPasswordRoute: typeof UnauthenticatedResetPasswordRoute
  UnauthenticatedVerifyEmailRoute: typeof UnauthenticatedVerifyEmailRoute
  UnauthenticatedRegisterAgencyRoute: typeof UnauthenticatedRegisterAgencyRoute
  UnauthenticatedRegisterIndexRoute: typeof UnauthenticatedRegisterIndexRoute
}

const UnauthenticatedRouteChildren: UnauthenticatedRouteChildren = {
  UnauthenticatedLoginRoute: UnauthenticatedLoginRoute,
  UnauthenticatedOnboardingRoute: UnauthenticatedOnboardingRoute,
  UnauthenticatedRequestResetRoute: UnauthenticatedRequestResetRoute,
  UnauthenticatedResetPasswordRoute: UnauthenticatedResetPasswordRoute,
  UnauthenticatedVerifyEmailRoute: UnauthenticatedVerifyEmailRoute,
  UnauthenticatedRegisterAgencyRoute: UnauthenticatedRegisterAgencyRoute,
  UnauthenticatedRegisterIndexRoute: UnauthenticatedRegisterIndexRoute,
}

const UnauthenticatedRouteWithChildren = UnauthenticatedRoute._addFileChildren(
  UnauthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  UnauthenticatedRoute: UnauthenticatedRouteWithChildren,
  ExploreBrandsRoute: ExploreBrandsRoute,
  InfluencersListRoute: InfluencersListRoute,
  PackagesRoute: PackagesRoute,
  VerifyAccountRoute: VerifyAccountRoute,
  VerifyEmailChangeRoute: VerifyEmailChangeRoute,
  WelcomeRoute: WelcomeRoute,
  JoinSlugRoute: JoinSlugRoute,
  UnsubscribeTokenRoute: UnsubscribeTokenRoute,
  EmbedJoinSlugRoute: EmbedJoinSlugRoute,
  CampaignCampaignIdIndexRoute: CampaignCampaignIdIndexRoute,
  InfluencerInfluencerIdIndexRoute: InfluencerInfluencerIdIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
